import React from "react";
import { ContainnerProvider } from "@qt-rc/bms";
import { AudioProvider } from "@qt-rc/global-audio";
import "@qt-base/css-common";
import "@qt-rc/bms/dist/style.css";
import "@qt-rc/bms-marketing/dist/style.css";
import "@qt-base/linkedme";
import "@qt-base/jssdk";
import "@qt-rc/common-expose";
import "@qt-rc/modal";
import "@qt-rc/toast";
import { Image } from "@qt-rc/bms";
import { TimeController } from "@qt-rc/bms";
import { BaseLayout } from "@qt-rc/bms";
import { AudioContext } from "@qt-rc/global-audio";
import { Cps } from "@qt-rc/cps";
import "@qt-rc/cps/dist/style.css";
import { FixedRule } from "@qt-rc/bms";
import { CountDown } from "@qt-rc/bms";
import { ImageModal } from "@qt-rc/bms";
import { MemberController } from "@qt-rc/bms";
import { TaskController } from "@qt-rc/bms";
import { ReceiveTask } from "@qt-rc/bms-marketing";
import "swiper";
import { ModalSlide } from "@qt-rc/bms";
import { FlexibleDraw } from "@qt-rc/flexible-draw";
import "@qt-rc/flexible-draw/dist/style.css";
import { SwiperContainer } from "@qt-rc/bms";
import { TabNavs } from "@qt-rc/bms";
import { HotZone } from "@qt-rc/bms";
window.__BUILDER_PROJECT_ID = '64311a4ac2277cbfaffb9a1f';
window.__BUILDER_PAGE_ID = '64311a4ac2277cbfaffb9a22';
console.log('linkedme', window.linkedme);
if (window.linkedme) window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);

const WrapContainer = ({
  id: id,
  nodeId: nodeId,
  nodeType: nodeType,
  children: children,
  pageConfig: pageConfig,
  appShareConfig: appShareConfig,
  timeConfig: timeConfig
}) => {
  console.log('current env is: ', process.env.SITE_ENV);
  return <ContainnerProvider id={id} nodeId={nodeId} nodeType={nodeType} children={children} pageConfig={pageConfig} appShareConfig={appShareConfig} timeConfig={timeConfig} env={process.env.SITE_ENV}>
      <AudioProvider>{children}</AudioProvider>
    </ContainnerProvider>;
};

const imageConfig = {
  src: "https://bp.qtfm.cn/bms/images/64311a4ac2277cbfaffb9a1f/61af41c3e6bf3acd1301ccb309acedf7.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const timeConfig__2 = {
  startTime: "2023-03-30 10:26:57",
  endTime: "2023-04-16 23:09:45",
  dynamicCheck: true,
  checkDuration: 10
};
const baseLayoutStyle = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "relative",
  "zIndex": 10
};
const cpsConfig = {
  itemId: "6426b47b0474d9474bb9b34c",
  productConfig: {
    cover: "https://bp.qtfm.cn/bms/images/64311a4ac2277cbfaffb9a1f/e1b39e571a82b66610724e218ca0eb53.jpg",
    name: "蜻蜓FM超级会员年卡",
    desc: "1折买7家会员年卡！"
  },
  posterTemplate: {
    price: "",
    secondPrice: "",
    motivate_pattern_txt: "",
    motivate_orders_txt: "",
    motivate_money_txt: "",
    useTemplate: true,
    poster: "https://pic.qtfm.cn/material/distribution/poster/light/03.jpg",
    posterPreview: "https://pic.qtfm.cn/material/distribution/poster/preview.jpg",
    customPoster: "https://bp.qtfm.cn/bms/images/64311a4ac2277cbfaffb9a1f/97b3cff8aa988493f1ed10e13428a2c5.jpg",
    mode: "light"
  },
  pageConfig: {
    playProgramCount: true,
    richTextDesc: true,
    puchaseNote: "4月10日-4月16日期间，邀请好友购买蜻蜓FM超级会员\"买1得7听书节限定商品\"，好友成功购买后，即可获得邀请奖励10元。",
    avoidShield: true,
    limitCps: false,
    secondCps: false,
    openGuidePng: true
  },
  openLimit: false,
  specialUser: ""
};
const baseLayoutStyle__5 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "relative",
  "bottom": 0,
  "top": "-13.5rem",
  "zIndex": 13
};
const fixedRuleConfig = {
  buttonImgUrl: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/3f755c2a19b613bd22a8f2d83a3bbe03.png",
  ruleContent: "<h4 style=\"font-size: 14px;\"><strong>一、年卡商品超级赠礼规则</strong></h4><h5 style=\"font-size: 14px;\"><strong>1、活动期说明</strong></h5><p style=\"font-size: 14px;\">2023年4月10日00:00:00-2023年4月16日23:59:59</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h5 style=\"font-size: 14px;\"><strong>2、购买商品说明</strong></h5><p style=\"font-size: 14px;\">1）活动期内，购买蜻蜓FM年卡，可获得蜻蜓FM会员权益的同时，也可享受指定品牌会员超级赠礼，超级赠礼数量有限，送完即止。</p><p style=\"font-size: 14px;\">2）因超级赠礼数量有限，如因活动火爆导致超级赠礼提前售罄，则超级赠礼活动将提前结束。超级赠礼活动结束后，用户可继续购买会员商品，但不包含任何品牌会员超级赠礼。蜻蜓FM可能会视情况进行超级赠礼活动的返场活动，具体以届时活动约定为准。</p><p style=\"font-size: 14px;\">3）在活动期内，同一蜻蜓账户仅限购买1次蜻蜓FM188年卡423限定年卡商品。</p><p style=\"font-size: 14px;\">4）本活动商品为虚拟会员服务商品，一经售出，概不退货退款。</p><p style=\"font-size: 14px;\">5）本活动商品因属于分销赚佣金活动商品，属于优惠特价商品，禁止使用蜻蜓币等虚拟货币支付。</p><p style=\"font-size: 14px;\">注：品牌会员超级赠礼可能因数量有限等原因存在不定时修改情形，蜻蜓FM不承诺超级赠礼内容持续不变，具体以页面公布的最新超级赠礼为准，请您在购买前仔细核对页面超级赠礼详情。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h5 style=\"font-size: 14px;\"><strong>3、领取会员权益说明</strong></h5><p style=\"font-size: 14px;\">1）本活动商品购买成功后，已购买的蜻蜓FM超级会员时长会自动充值到登录的蜻蜓FM账号中，品牌超级赠礼将发放至我的赠礼页面：<a href=\"https://sss.qingting.fm/vips/members/v2/presents.html\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"color: rgb(0, 82, 204);\">https://sss.qingting.fm/vips/members/v2/presents.html</a>，如遇到网络问题等原因可能会存在延迟到账的情况，一般在24小时内可到账，请耐心等待后查看到账情况。</p><p style=\"font-size: 14px;\">2）芒果TV年卡、搜狐视频年卡、唯品会年卡、PP视频年卡、快看漫画年卡会员赠礼需要用户在成功购买后3天内在我的赠礼页页面：<a href=\"https://sss.qingting.fm/vips/members/v2/presents.html\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"color: rgb(0, 82, 204);\">https://sss.qingting.fm/vips/members/v2/presents.html</a>领取，如您未在前述期限内及时领取的，则视为您放弃相应赠礼权益，请您注意及时领取，否则由此产生的损失由您自行承担，蜻蜓FM平台不支持任何逾期赠礼的领取服务或其他补偿服务。</p><p style=\"font-size: 14px;\"><strong>3）月月领赠礼蜻蜓FM月卡或腾讯视频月卡，在成功购买后在我的赠礼页页面：</strong><a href=\"https://sss.qingting.fm/vips/members/v2/presents.html\" rel=\"noopener noreferrer\" target=\"_blank\" style=\"color: rgb(0, 82, 204);\">https://sss.qingting.fm/vips/members/v2/presents.html</a><strong>领取；首次及此后每月释放领取机会后，在蜻蜓FM月卡或腾讯视频月卡赠礼会员中任选一个领取，共计可领取12次。</strong></p><p style=\"font-size: 14px;\">4）品牌会员超级赠礼领取时，如您因填错/登陆错账号或者误操作等原因导致充值或领取到错误账号，蜻蜓FM不支持退换或退款，请您在领取前务必仔细核对账号。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h5 style=\"font-size: 14px;\"><strong>4、超级赠礼说明</strong></h5><p style=\"font-size: 14px;\">1）本次活动品牌会员超级赠礼由各合作品牌提供，详细权益介绍、权益服务有效期说明、权益使用规则、客服联系方式以合作品牌平台公布的内容为准，有关联合会员的权益可能存在不定期修改的情况，具体以品牌方最新权益为准。</p><p style=\"font-size: 14px;\">2）本次活动品牌会员超级赠礼领取方式分为手机号充值领取和兑换码充值领取，部分赠品仅支持蜻蜓绑定手机号领取。</p><p style=\"font-size: 14px;\"><strong>3）本次活动品牌会员超级赠礼按发放形式分为赠礼与月月领赠礼。注：赠礼为购买超级会员商品后一次性到账的附加权益，月月领赠礼为超级会员商品后分月到账的附加权益。以下统称赠礼与月月领赠礼为超级赠礼。</strong></p><p style=\"font-size: 14px;\"><strong>4）本次活动品牌会员超级赠礼中，普通赠礼有：芒果TV年卡、搜狐视频年卡、唯品会年卡、PP视频年卡、快看漫画年卡；月月领赠礼有：蜻蜓FM月卡/腾讯视频月卡，首次及此后每月释放领取机会后，任选1个品牌会员领取，共计可领取12次。</strong></p><p style=\"font-size: 14px;\"><strong>赠礼领领取规则：取有效期为3天，请您在有效期内及时领取，及时绑定相应手机号账户进行领取或领取相应兑换码进行兑换，如您未在有效期内领取充值或兑换的，则视为您放弃相应赠礼权益,不予补发。</strong></p><p style=\"font-size: 14px;\"><strong>月月领赠礼领取规则：第一次领取机会可在完成指定会员商品购买后即刻领取，第一次领取机会有效领取时间截止到完成订单时间后30天。此后剩余领取机会有效期为：订单完成月份的下一个月份开始，每个自然月1号0点至最后一天24点（即此后每月发放一次领取机会），请您在有效期内及时领取，及时绑定相应手机号账户进行领取或领取相应兑换码进行兑换，如您未在有效期内领取充值或兑换的，则视为您放弃相应月月领赠礼权益,不予补发。</strong></p><p style=\"font-size: 14px;\">5）超级赠礼是用户购买蜻蜓FM会员商品的附属权益，您不得在其他平台进行转售、倒卖或蜻蜓FM/合作方禁止的行为，不得通过不正当手段获取超级赠礼进行盈利，任何未经蜻蜓FM及/或超级赠礼品牌方明示授权而销售、转让蜻蜓FM会员商品/会员资格或超级赠礼/超级赠礼获取资格的行为，属于非法销售、非法转让，一经发现，蜻蜓FM有权收回您的所有超级赠礼权益，且有权追究其法律责任。</p><p style=\"font-size: 14px;\">购买商品前请注意以下超级赠礼规则：</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\"><strong>关于赠礼芒果TV会员：</strong></p><p style=\"font-size: 14px;\">赠礼芒果TV会员激活有效期：购买后3天内，请在有效期内至我的赠礼页面兑换，过期作废；</p><p style=\"font-size: 14px;\"><strong>芒果TV会员激活说明：</strong></p><p style=\"font-size: 14px;\">1）芒果TV会员<strong>仅支持购买活动年卡的蜻蜓手机号领取</strong>，并且同一个手机号和同一个设备仅限领取一次，不支持更换账号领取。</p><p style=\"font-size: 14px;\">2）芒果TV会员使用限制：芒果TV会员为芒果TV的PC移动影视会员，仅适用于手机+iPad+电脑，不包含电视端的权益。</p><p style=\"font-size: 14px;\"><strong>芒果TV会员使用咨询：</strong>如有疑问可联系客服，客服联系方式：400-6770-707</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\"><strong>关于赠礼搜狐视频会员：</strong></p><p style=\"font-size: 14px;\"><strong>搜狐视频会员激活有效期：</strong>购买后3天内，请在有效期内至我的赠礼页面兑换，过期作废；</p><p style=\"font-size: 14px;\"><strong>搜狐视频会员激活说明：</strong></p><p style=\"font-size: 14px;\">1）基于合作平台会员规则，同一手机号仅可充值1次，若您达到充值上限，则您将无法继续使用该手机帐号领取。</p><p style=\"font-size: 14px;\">2）如果您尚未注册或绑定搜狐视频账号，我们将为您生成一个新账号进行领取，一旦领取我们将默认您已同意注册搜狐视频新账号。</p><p style=\"font-size: 14px;\"><strong>搜狐视频会员使用咨询：</strong>如有疑问可联系客服，客服电话400-881-6666</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\"><strong>关于赠礼pp视频会员：</strong></p><p style=\"font-size: 14px;\"><strong>pp视频会员激活有效期：</strong><span style=\"color: rgb(0, 0, 0);\">购买后3天内，请在有效期内至我的赠礼页面兑换，过期作废；</span></p><p style=\"font-size: 14px;\"><strong>pp视频会员激活说明：</strong></p><p style=\"font-size: 14px;\">用户在我的赠礼页面，需输入手机号领取赠礼，购买前请您一定要仔细核对充值账号，如因误充导致充值失败或充值到其它账户，不予退款；</p><p style=\"font-size: 14px;\"><strong>pp视频会员使用咨询：</strong>如有疑问可联系客服：400-001-2094</p><p style=\"font-size: 14px;\"><strong>关于赠礼唯品会超级VIP：</strong></p><p style=\"font-size: 14px;\"><strong>唯品会超级VIP激活有效期：</strong>购买后3天内，请在有效期内至我的赠礼页面兑换，过期作废；</p><p style=\"font-size: 14px;\"><strong>唯品会超级VIP激活说明：</strong></p><p style=\"font-size: 14px;\">1）基于合作平台会员规则，同一唯品会账号（即同一手机号）同一类型会员最多可充值1年唯品会超级VIP。</p><p style=\"font-size: 14px;\">2）唯品会超级VIP<strong>仅支持购买活动年卡的蜻蜓手机号</strong>领取，并且同一个手机号和同一个设备仅限领取一次，不支持更换账号领取。</p><p style=\"font-size: 14px;\">3）若您的唯品会账号在使用唯品会服务期间有其他违规行为，将无法充值到账。</p><p style=\"font-size: 14px;\">4）如果您尚未注册或绑定唯品会APP，我们将为您生成一个新账号进行领取，一旦领取我们将默认您已同意注册唯品会新账号。</p><p style=\"font-size: 14px;\"><strong>唯品会超级VIP使用咨询：</strong>如有疑问可联系客服，客服联系方式：400-6789-888。</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\"><strong>关于赠礼快看漫画会员：</strong></p><p style=\"font-size: 14px;\"><strong>快看漫画会员激活有效期：</strong>购买后3天内，请在有效期内至我的赠礼页面兑换，过期作废；</p><p style=\"font-size: 14px;\"><strong>快看漫画会员激活说明：</strong></p><p style=\"font-size: 14px;\">1）基于合作平台会员规则，快看漫画会员<strong>仅支持购买活动年卡的蜻蜓手机号领取</strong>，并且同一个手机号和同一个设备仅限领取一次，不支持更换账号领取。</p><p style=\"font-size: 14px;\">2）快看漫画会员使用限制：会员权益仅支持在APP端/PC端/PAD端使用，不支持TV端。</p><p style=\"font-size: 14px;\"><strong>快看漫画会员使用咨询：</strong>如有疑问可联系客服，客服联系方式：关注微信公众号“快看漫画club”，点击底部键盘按钮输入问题即可得到回复，工作时间：周一至周日9:30-12:00，13:30-19:00。</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\"><strong>关于月月领赠礼腾讯视频会员：</strong></p><p style=\"font-size: 14px;\"><strong>腾讯视频会员激活有效期：</strong>购买后首次领取有效期截止到完成订单时间后30天，此后领取有效期为：订单完成月份的下一个月份开始，每个自然月1号0点至最后一天24点（即此后每月发放一次领取机会），请您在有效期内至我的赠礼页面兑换，过期作废；</p><p style=\"font-size: 14px;\"><strong>腾讯视频会员激活说明：</strong></p><p style=\"font-size: 14px;\">1）基于合作平台会员规则，腾讯视频会员<strong>仅支持输入微信账号/QQ账号领取，</strong>由于会员产品为虚拟商品，一经开通，不支持退款或会员转移，请在开通前务必核对账号信息，避免充值到错误账号，如因错误填写账号信息等原因，均不支持退款；</p><p style=\"font-size: 14px;\">2）腾讯视频VIP权益范围（手机、电脑、PAD可用）；</p><p style=\"font-size: 14px;\"><strong>腾讯视频会员使用咨询：</strong>腾讯视频官方客服联系方式：4006700700（人工服务时间：9:00-22:00，自助语音时间：7X24小时）</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\">5、其他注意事项</p><p style=\"font-size: 14px;\">1）若您存在以下违反平台规定行为的，您将无法参与相关活动或领取超级赠礼会员权益：</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><ul><li style=\"font-size: 14px;\">活动期间内续费达上限、恶意注册用户、有恶意购买行为、涉嫌非自用目的购买用户及其他蜻蜓FM超级会员或合作品牌会员权益合作平台认定为可能不恰当获得/使用会员身份的用户。</li><li style=\"font-size: 14px;\">曾存在违法蜻蜓FM超级会员用户协议或其他合作平台的有关用户协议或规定的行为。</li></ul><p style=\"font-size: 14px;\">2）参与活动的用户都应遵守蜻蜓FM超级会员及合作品牌会员平台各自发布的用户服务协议、隐私政策、会员服务协议、活动规则及其他相关法律文件的规定，如违反，蜻蜓FM及合作平台均有权单独按照其平台的相关法律文件进行处理，包括但不限于终止或中止提供所有平台的服务及要求侵权赔偿等，故在购买前请仔细阅读各平台的相关协议、规则等，一经购买即视为您已仔细阅读、充分理解并同意各方的相关协议、规则及法律文件。</p><p style=\"font-size: 14px;\">3）蜻蜓FM可根据实际情况，对本活动规则进行变动或调整，相关变动或调整将公布在活动页面上，并于公布时即时生效，对于您在活动规则变动或调整前已经购买的会员服务，蜻蜓FM将继续按照您购买时的活动规则提供相应服务。</p><p style=\"font-size: 14px;\">4）任何以盗窃、刷量、利用系统漏洞、通过任何非蜻蜓FM官方或授权途径等非法、违规方式参与本次活动获取的福利，均不获保护。一经发现，蜻蜓FM有权立即就相关服务做出删除、取消、清零等处理，或采取其他如中止或终止对您提供服务等账号管理措施，所有因此产生的损失及责任由您自行承。</p><p style=\"font-size: 14px;\">5）如在使用蜻蜓FM超级会员过程中有任何疑问,请通过【蜻蜓FM】-【个人中心】-【帮助与反馈】-【联系客服】联系客服进行咨询。</p><p style=\"font-size: 14px;\">以上内容，请您在认真阅读并清楚理解相关活动规则后自主决定是否参加，如您参加，则视为您已清楚了解活动规则并同意遵守。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h4 style=\"font-size: 14px;\"><strong>二、亲友礼品卡VIP15天畅听</strong></h4><p style=\"font-size: 14px;\"><strong>1、礼品卡是什么？</strong></p><p style=\"font-size: 14px;\">礼品卡属于蜻蜓FM推出的为亲友关系打造的会员/专辑畅听券赠送功能，礼品卡一经获取，可分享给亲友免费领取，与他们一起共享听书时光。</p><p style=\"font-size: 14px;\">会员礼品卡是指用户获取后可赠送给亲友的免费会员体验资格，专辑畅听券礼品卡是指用户获取后可赠送给其亲友的指定会员专辑的免费天数收听资格。</p><p style=\"font-size: 14px;\"><strong>2、如何获取礼品卡？</strong></p><p style=\"font-size: 14px;\">423活动期间，购买活动商品，即可获得一张礼品卡，一张礼品卡可以赠送给三个亲友。</p><p style=\"font-size: 14px;\"><strong>3、如何查看和赠送礼品卡？</strong></p><p style=\"font-size: 14px;\">您可在蜻蜓FM手机客户端-【个人中心】-【VIP超级会员】-【礼品】-【礼品卡】页面中关注礼品卡获取、赠送、领取等情况。</p><p style=\"font-size: 14px;\"><strong>4、礼品卡使用规则</strong></p><p style=\"font-size: 14px;\">1）【礼品卡】属于蜻蜓FM推出的为亲友关系打造的会员/专辑畅听券赠送功能，礼品卡一经获取，可分享给亲友免费领取，与他们一起共享听书时光。</p><p style=\"font-size: 14px;\">2）【423礼品卡】属于蜻蜓FM用户423听书节活动期间购买超级会员活动商品后的附加权益，423听书节活动礼品卡为可以赠送给亲友领取的15天蜻蜓FM会员卡，用户成功购买423超级会员活动商品后，附加权益礼品卡即时到账。您可在蜻蜓FM手机客户端【个人中心-VIP超级会员-礼品卡】中关注领取、赠送情况。</p><p style=\"font-size: 14px;\">3）【423礼品卡】1张礼品卡对应3份赠送资格，赠送礼品卡的用户以下简称“分享者”，受赠礼品卡的用户以下简称“被分享者”。</p><p style=\"font-size: 14px;\">4）【礼品卡】即时到账后，有效赠送时间为30天。分享者可至【礼品卡】页面，选择在有效期内未送完的礼品卡赠送给亲友。</p><p style=\"font-size: 14px;\">5）礼品卡仅限被分享的亲友领取，分享者本人不可领取。同一礼品卡赠送链接，每位亲友仅限领取1次，单个亲友不可重复领取同一礼品卡。</p><p style=\"font-size: 14px;\">6）礼品卡分享给亲友后，亲友领取有效期为3天。如超过有效期3天亲友未领取，礼品卡将退回分享者账户，分享者可将礼品卡赠送给其他符合领取条件的亲友。</p><p style=\"font-size: 14px;\">7）礼品卡分享链接转发给亲友后，亲友亦可帮你分享链接进行转赠。礼品卡达到领取上限后即失效，不可超额领取。为减少可能存在的财产损失风险，转赠时请谨慎。</p><p style=\"font-size: 14px;\">8）若用户违反诚实信用原则或出现违规行为（如作弊领取、恶意套取或其他通过技术、反编译手段进行违规领取等）， 蜻蜓FM将取消该用户获得权益的资格，且所有责任由用户自行承担。</p><p style=\"font-size: 14px;\">9）如您有任何疑问或需要帮助，可在【蜻蜓FM APP-个人中心-帮助与反馈-联系客服】中咨询在线客服。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h4 style=\"font-size: 14px;\"><strong>三、分享亲友礼品卡立得30天会员</strong></h4><p style=\"font-size: 14px;\">1、活动时间：2023年4月10日00:00:00-2023年4月16日23:59:59期间；</p><p style=\"font-size: 14px;\">2、活动说明：</p><p style=\"font-size: 14px;\">1）用户在活动期间购买活动页面188活动年卡后，礼品卡即时到账（您可在【个人中心-VIP超级会员-礼品卡】查看礼品卡到账情况，如遇到网络问题等原因可能会存在延迟到账的情况，一般在24小时内可到账，请耐心等待后查看到账情况），</p><p style=\"font-size: 14px;\">2）成功分享礼品卡给你的好友，分享者可获得额外+30天蜻蜓FM会员奖励。</p><p style=\"font-size: 14px;\">3、分享者领取+30天蜻蜓FM会员时长时，必须同时满足以下条件：</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><ul><li style=\"font-size: 14px;\">活动期间：2023年4月10日00:00:00-2023年4月16日23:59:59；</li><li style=\"font-size: 14px;\">购买188元423活动限定年卡商品；</li><li style=\"font-size: 14px;\">成功分享礼品卡给好友（注：分享者分享给除本人外的亲友或社交朋友圈，即视为分享成功）；</li></ul><p style=\"font-size: 14px;\">4、此任务在活动期间，仅限完成一次。即用户购买多次188元年卡，多次分享给不同亲友，也只能领取一次30天会员额外时长。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h4 style=\"font-size: 14px;\"><strong>四、扭蛋活动规则</strong></h4><p style=\"font-size: 14px;\">1、活动时间：</p><p style=\"font-size: 14px;\">2023年4月10日00:00:00-2023年4月26日23:59:59</p><p style=\"font-size: 14px;\">奖品领取时间：</p><p style=\"font-size: 14px;\">2023年4月10日00:00:00-2023年4月26日23:59:59</p><p style=\"font-size: 14px;\">2、符合以下条件的用户可获得抽奖机会:</p><p style=\"font-size: 14px;\">购买福利：</p><p style=\"font-size: 14px;\">2023年4月10日0:00:00-2023年4月16日23:59:59购买<span style=\"color: rgb(44, 62, 80);\">423活动限定超级会员年卡</span>即可获得3次抽奖机会。通过购买此年卡的方式，每个用户最多获得3次抽奖机会。</p><p style=\"font-size: 14px;\">2023年4月17日0:00:00-2023年4月23日23:59:59购买<span style=\"color: rgb(44, 62, 80);\">423活动限定超级会员年卡</span>即可获得3次抽奖机会。通过购买该年卡的方式，每个用户最多获得3次抽奖机会。</p><p style=\"font-size: 14px;\">2023年4月24日0:00:00-2023年4月26日23:59:59购买<span style=\"color: rgb(44, 62, 80);\">423活动</span>场活动<span style=\"color: rgb(44, 62, 80);\">限定超级会员年卡</span>超级会员98年卡即可获得3次抽奖机会。通过购买该年卡的方式，每个用户最多获得3次抽奖机会。</p><p style=\"font-size: 14px;\">3、奖品说明:</p><p style=\"font-size: 14px;\">1）蜻蜓FM会员卡奖品,将在24小时内充值到账;</p><p style=\"font-size: 14px;\">2）实物奖品：小米手机、小米手环、小米牙刷、fiil降噪无线耳机、儿童周边礼品、搪瓷杯将在活动结束后30个工作日内发放,请中奖用户在活动期结束前（2023年4月26日23:59:59前）及时按照要求填写真实个人信息（个人姓名+身份证号+收货地址+手机号），用于为用户申报缴纳个税以及邮寄奖品，若因用户未及时填写或未正确填写导致无法申报个税或邮寄奖品，则视为用户自动放弃奖品；</p><p style=\"font-size: 14px;\">3）现金奖品：将在活动结束后30个工作日内联系用户提供个人支付宝或者微信账户，请中奖用户在活动期结束前（2023年4月26日23:59:59前）及时按照要求填写真实个人信息（个人姓名+身份证号+手机号），用于为用户申报缴纳个税，若因用户未及时填写或未正确填写联系方式导致联系不上，以及无法申报个税，则视为用户自动放弃奖品；</p><p style=\"font-size: 14px;\">4）活动过程中，若用户存在刷奖、恶意刷取券码、重复领取、使用外挂/插荐以及其他工具等不正当手段故意或者恶意违规的行为，违反诚实信用原则及违背活动公平原则的方式参与本次活动，将取消该用户中奖资格，取消对应的奖品，或取消其后续参与平台活动的资格。蜻蜓FM保留追究其法律责任的权利。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h4 style=\"font-size: 14px;\"><strong>五、分销规则</strong></h4><h5 style=\"font-size: 14px;\"><strong>1、活动时间：</strong></h5><p style=\"font-size: 14px;\">2023年4月10日00:00:00-2023年4月23日23:59:59； (如超级赠礼送完，则活动时间可能提前结束）</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h5 style=\"font-size: 14px;\"><strong>2.、活动规则</strong></h5><p style=\"font-size: 14px;\">您可在活动页面点击【分享赚10元】按钮，邀请您的好友购买蜻蜓FM423限定活动商品，当您的好友成功购买后，您可获得现金奖励。具体规则如下：</p><p style=\"font-size: 14px;\">•您在活动页面点击【分享赚10元】按钮后，即可生成您的专属活动海报，如果您的好友通过您的专属活动页面成功购买蜻蜓FM423限定活动商品，则您可获得10元现金奖励。</p><p style=\"font-size: 14px;\">• 此种分享奖励不发生类推或递延，即除本规则明确说明的推广奖励外，不再有其他奖励，若您的好友按照上述步骤再次对外分享形成有效购买，您不会因此再获奖励。</p><p style=\"font-size: 14px;\">• 如果您的好友购买成功后发生退款退货情況的，则您无法获得任何现金奖励；</p><p style=\"font-size: 14px;\">•如果您通过自己的专属活动页面购买蜻蜓FM423限定活动商品的，则针对该笔订单，您无法获得任何现金奖励。</p><p style=\"font-size: 14px;\">•本活动商品因属于分销赚佣金活动商品，属于优惠特价商品，您的好友通过您分享的页面购买时，禁止使用蜻蜓币等虚拟货币支付。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h5 style=\"font-size: 14px;\"><strong>3、活动特别说明</strong></h5><p style=\"font-size: 14px;\">1）因超级赠礼数量有限，如因活动火爆导致超级赠礼提前售罄，则本活动将提前结束。</p><p style=\"font-size: 14px;\">2）请您特别注意：本活动仅支持除蜻蜓FM APP以外终端（包括微信扫码、支付宝扫码等）扫码分享，如您的好友使用蜻蜓FM App扫码购买活动商品，则您无法获得任何现金奖励，如您的好友使用蜻蜓FM APP扫码进行二次分享，将无法生成专属活动页面，亦无法获得任何现金奖励。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h5 style=\"font-size: 14px;\"><strong>4、提现说明</strong></h5><p style=\"font-size: 14px;\">1）关于收益查看：您的好友通过您的专属活动页面成功购买活动商品的，您即可前往“蜻蜓FM-个人中心-余额提现”模块查看好友购买明细以及现金奖励收益。分销成功后佣金到账可能存在延迟情况，余额展示也会存在延迟情况，一般15min内可再次查看。&nbsp;</p><p style=\"font-size: 14px;\">2）关于提现流程及提现时间：获得的现金奖励将在好友购买后N+7天到账【当前余额】，好友购买后，您可以在【蜻蜓FM】-【个人中心】一【即将到账】中查看您的返点情况，N+7天后将到账您的账户，用户可【蜻蜓FM】-【个人中心】一【余额提现】模块发起提现申请。</p><p style=\"font-size: 14px;\">3）请您注意，若因系统繁忙等原因，可能出现提现金额延迟到账情况，一般在24小时内可到账，若您在发起提现申请后发现提现金额尚未到账的，请耐心等待后再查看到账情况;若24小时后仍未到账的，您可联系客服咨询及处理。</p><p style=\"font-size: 14px;\">4）关于提现规则要求：</p><p style=\"font-size: 14px;\">•分销佣金将于分销订单完成日的7天后到账。期间订单发生退款行为，则视为结算失败，佣金无法到账。若分销佣金显示已冻结，则该订单处于异常状态，请联系人工客服重新发起结算。</p><p style=\"font-size: 14px;\">•单次提现金额最低为5元，最高为5000元，每个蜻蜓FM账号每天最多提现3次;</p><p style=\"font-size: 14px;\">•仅支持提现至微信余额账户，提现前请将您的蜻蜓FM账号与微信账号进行綁定，并保证您的微信账号已经完成实名认证，否则将无法完成提现;</p><p style=\"font-size: 14px;\">•若同一实名用户在一个自然月内累计提现超过800元的，请配合页面提示提供身份信息（个人姓名＋个人身份证号），以便蜻蜓FM按照 《中华人民共和国个人所得税法》等相关规定，为用户代扣代缴相关税费，如同一实名用户持有多个蜻蜓FM账户，多个账号的相应收益将进行累计计算。</p><p style=\"font-size: 14px;\">&nbsp;</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h4 style=\"font-size: 14px;\"><strong>六、其他注意事项</strong></h4><p style=\"font-size: 14px;\">1）活动商品如有附随超级赠礼的，相关超级赠礼是用户购买蜻蜓FM超级会员商品的附属权益，您不得在其他平台进行转售、倒卖或蜻蜓FM/合作方禁止的行为，不得通过不正当手段获取超级赠礼进行盈利，任何未经蜻蜓FM及/或超级赠礼品牌方明示授权而销售、转让蜻蜓FM会员商品/会员资格或超级赠礼/超级赠礼获取资格的行为，属于非法销售、非法转让，一经发现，蜻蜓FM有权收回您的所有超级赠礼权益，且有权追究其法律责任。</p><p style=\"font-size: 14px;\">2）活动过程中，若用户存在刷奖、恶意刷取券码、重复领取、使用外挂/插件以及其他工具等不正当手段等故意或者恶意违规、影响活动公正的行为，违反诚实信用原则及违背活动公平原则的方式参与本次活动，将取消该用户中奖资格，取消对应的奖品，或取消其后续参与平台活动的资格。蜻蜓FM保留追究法律责任的权利。</p><p style=\"font-size: 14px;\">3）参与活动的用户都应遵守蜻蜓FM超级会员及合作品牌会员平台各自发布的用户服务协议、隐私政策、会员服务协议、活动规则及其他相关法律文件的规定，如违反，蜻蜓FM及合作平台均有权单独按照其平台的相关法律文件进行处理，包括但不限于终止或中止提供所有平台的服务及要求侵权赔偿等，故在购买前请仔细阅读各平台的相关协议、规则等，一经购买即视为您已仔细阅读、充分理解并同意各方的相关协议、规则及法律文件。</p><p style=\"font-size: 14px;\">4）蜻蜓FM可根据实际情况，对本活动规则进行变动或调整，相关变动或调整将公布在活动页面上，并于公布时即时生效，对于您在活动规则变动或调整前已经购买的会员服务，蜻蜓FM将继续按照您购买时的活动规则提供相应服务。</p><p style=\"font-size: 14px;\">5）如在使用蜻蜓FM超级会员过程中有任何疑问,请通过【蜻蜓FM】-【个人中心】-【帮助与反馈】-【联系客服】联系客服进行咨询，服务时间：北京时间09:30-18:30。&nbsp;</p><p style=\"font-size: 14px;\">以上内容，请您在认真阅读并清楚理解相关活动规则后自主决定是否参加，如您参加，则视为您已清楚了解活动规则并同意遵守。</p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><p style=\"font-size: 14px;\"><br></p><h4 style=\"font-size: 14px;\"><br></h4>",
  ruleContentHeight: 200
};
const fixedRuleStyle = {
  "position": "absolute",
  "width": "1.2rem",
  "top": "1.2rem",
  "right": "0rem",
  "zIndex": 2,
  "lineHeight": "1",
  "marginTop": 0
};
const imageConfig__7 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/2020c2f592e5056f94edcdd0f912ed99.png",
  link: "https://bp.qtfm.cn/qt-pages/gifts/home.html",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__7 = {
  "position": "absolute",
  "width": "1.2rem",
  "right": "0rem",
  "zIndex": 2,
  "boxSizing": "border-box",
  "top": "2.1rem"
};
const imageConfig__8 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/825ff72ff1d370fb61bea69278a65fd0.png",
  link: "https://sss.qtfm.cn/vips/members/v2/presents.html",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__8 = {
  "position": "absolute",
  "width": "1.2rem",
  "right": "0rem",
  "zIndex": 2,
  "boxSizing": "border-box",
  "top": "1.65rem"
};
const baseLayoutStyle__9 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const imageConfig__10 = {
  src: "https://bp.qtfm.cn/bms/images/64311a4ac2277cbfaffb9a1f/2f183bb3c8b8c06819f32078b817dae3.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__10 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const countDownConfig = {
  endTime: "2023-04-16 23:59:59",
  prefixText: "限时：",
  endText: "活动结束啦"
};
const countDownStyle = {
  "color": "#a3e4f9",
  "fontWeight": 400,
  "fontSize": "14px",
  "position": "absolute",
  "display": "inline-block",
  "zIndex": 1,
  "paddingBottom": 0,
  "left": "2.3rem",
  "top": "1rem",
  "paddingTop": 0
};
const baseLayoutStyle__12 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "left": "0.4rem",
  "marginTop": "-7.5rem",
  "zIndex": 1
};
const imageModalConfig = {
  icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/035d9590d38b7103ab2e21c6cc71fe96.png",
  iconEnlarged: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/095c923882876aecc6189d8b0562bd95.png",
  shareInApp: false,
  showUserNo: false,
  showNameAndAvatar: false,
  suffix: ""
};
const imageModalStyle = {
  "width": "3.2rem"
};
const autorenewConfig = {
  control: "0"
};
const discountConfig = {
  control: "0"
};
const boughtConfig = {
  control: "2",
  goodsIds: "6421443a0474d97f83b9b347,642144960474d9f7dfb9b348,6426b47b0474d9474bb9b34c,642a7db10474d90f64b9b34e",
  startTime: "2023-04-07 00:00:00",
  endTime: "2023-04-27 00:00:00"
};
const vipLevelConfig = {
  control: "0",
  currentVip: "",
  expiredVip: "",
  newUserNeverVip: "",
  oldUserNeverVip: ""
};
const couponConfig = {
  control: "0",
  code: ""
};
const taskConfig = {
  taskIds: 285,
  show: "1"
};
const baseLayoutStyle__16 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "marginTop": "-7.5rem",
  "right": "0.3rem",
  "zIndex": 1
};
const imageModalConfig__17 = {
  icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/5af3ffee6a4f8076d30d0e68ec68ffff.png",
  iconEnlarged: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/861f8b870984416b7fdb457add406951.jpg",
  shareInApp: false,
  showUserNo: false,
  showNameAndAvatar: false,
  suffix: ""
};
const imageModalStyle__17 = {
  "width": "3.2rem"
};
const autorenewConfig__18 = {
  control: "0"
};
const discountConfig__18 = {
  control: "0"
};
const boughtConfig__18 = {
  control: "1",
  goodsIds: "6421443a0474d97f83b9b347,642144960474d9f7dfb9b348,6426b47b0474d9474bb9b34c,642a7db10474d90f64b9b34e",
  startTime: "2023-04-07 00:00:00",
  endTime: "2023-04-27 00:00:00"
};
const vipLevelConfig__18 = {
  control: "0",
  currentVip: "",
  expiredVip: "",
  newUserNeverVip: "",
  oldUserNeverVip: ""
};
const couponConfig__18 = {
  control: "0",
  code: ""
};
const taskConfig__19 = {
  taskIds: 285,
  show: "1"
};
const baseLayoutStyle__20 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "marginTop": "-7.5rem",
  "right": "0.3rem",
  "zIndex": 1
};
const imageConfig__21 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/71c2afae17fb4e5d7a4e4a8a28d89d28.png",
  link: "https://bp.qtfm.cn/qt-pages/gifts/home.html",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__21 = {
  "marginLeft": "auto",
  "marginRight": "auto",
  "position": "relative",
  "width": "3.2rem",
  "left": 0,
  "right": 0,
  "zIndex": 1,
  "boxSizing": "border-box"
};
const autorenewConfig__22 = {
  control: "0"
};
const discountConfig__22 = {
  control: "0"
};
const boughtConfig__22 = {
  control: "1",
  goodsIds: "6421443a0474d97f83b9b347,642144960474d9f7dfb9b348,6426b47b0474d9474bb9b34c,642a7db10474d90f64b9b34e",
  startTime: "2023-04-07 00:00:00",
  endTime: "2023-04-27 00:00:00"
};
const vipLevelConfig__22 = {
  control: "0",
  currentVip: "",
  expiredVip: "",
  newUserNeverVip: "",
  oldUserNeverVip: ""
};
const couponConfig__22 = {
  control: "0",
  code: ""
};
const taskConfig__23 = {
  taskIds: 285,
  show: "2"
};
const baseLayoutStyle__24 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "marginTop": "-7.5rem",
  "right": "0.3rem",
  "zIndex": 1
};
const taskConfig__25 = {
  taskId: "285",
  notReceivedImg: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/ce0ae6e3a7077fbb4277bec52f6890f0.png",
  hasReceivedImg: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/04e837344939f066c8927a137e5ff31a.png",
  linkInApp: "",
  linkOutApp: ""
};
const taskStyle = {
  "position": "relative",
  "width": "3.2rem"
};
const baseLayoutStyle__26 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "zIndex": 1,
  "marginTop": "-4.6rem",
  "width": "5.8rem",
  "left": "1.3rem",
  "height": "100%"
};
const modalSlideConfig = {
  countPerRow: 5,
  data: [{
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/ee81dd37bfa957c92bf15f1d99a6c64d.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/f013e7e00a9552d32f0a773cf9c97faf.png",
    iconTitle: "",
    iconDesc: ""
  }, {
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/3add5024f44fd399058dcb0fc39dc740.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/36b6e5ddc7fe815ba3f180ec897b9305.png",
    iconTitle: "",
    iconDesc: ""
  }, {
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/515c8a84b702df035cf1d6e5ad29ad1c.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/3a508675c4bd6be876d1a227c02e8177.png",
    iconTitle: "",
    iconDesc: ""
  }, {
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/86e19af034e4104b6d54a3ccc2b1f1a8.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/8b94f7609a89ecc257ea03a1c522842f.png",
    iconTitle: "",
    iconDesc: ""
  }, {
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/0112706e8fdeec85ac6cf8875987af89.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/d2839c7682bc8eb3293acbb4d2dda1f0.png",
    iconTitle: "",
    iconDesc: ""
  }]
};
const modalSlideItemStyle = {
  width: "100"
};
const iconStyle = {
  "width": "1.2rem",
  "height": "1rem"
};
const titleStyle = {
  color: "red",
  fontSize: 12,
  lineHeight: 1.15,
  fontWeight: "bolder",
  marginTop: 2
};
const subTitleStyle = {
  color: "blue",
  fontSize: 10,
  lineHeight: 1.15,
  fontWeight: "normal",
  marginTop: 2
};
const baseLayoutStyle__28 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "zIndex": 1,
  "marginTop": "-3rem",
  "width": "5.8rem",
  "left": "1.3rem",
  "height": "0.9rem"
};
const modalSlideConfig__29 = {
  countPerRow: 2,
  data: [{
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/753e7f583c9ff8902c5a954779ee4c94.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/c376a0ec11aceb6bf86af484b4cb1023.png",
    iconTitle: "",
    iconDesc: ""
  }, {
    icon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/ca0c84330570cb2caeac18bf8cbc3fbc.png",
    modalIcon: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/095c923882876aecc6189d8b0562bd95.png",
    iconTitle: "",
    iconDesc: ""
  }]
};
const modalSlideItemStyle__29 = {
  width: "100"
};
const iconStyle__29 = {
  "width": "2.8rem",
  "height": "0.9rem"
};
const titleStyle__29 = {
  color: "red",
  fontSize: 12,
  lineHeight: 1.15,
  fontWeight: "bolder",
  marginTop: 2
};
const subTitleStyle__29 = {
  color: "blue",
  fontSize: 10,
  lineHeight: 1.15,
  fontWeight: "normal",
  marginTop: 2
};
const baseLayoutStyle__30 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const baseConfig = {
  activityID: 1161
};
const animationConfig = {
  animationDuration: 1000,
  beforeDrawImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/0fcb855b7527e3154dca3cd8550da133.jpg",
  drawingImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/3310e7231f56d9bf5dfd5f50def19165.gif"
};
const ruleStyleConfig = {
  style: {
    "backgroundImage": "url(https://bp.qtfm.cn/bms/image/6424f037c2277cbfaffb6628/09bd952ae5faea4025d984373c1d40e6.jpg)",
    "backgroundSize": "100% 100%",
    "paddingLeft": "15px",
    "paddingRight": "15px"
  },
  chanceColor: "#78eefb",
  ruleImage: "https://pic.qtfm.cn/ms-unknown/2020/03/23/d96e92eb1094c755972e7472156fcc9f/w192_h72.png",
  myPrizeImage: "https://pic.qtfm.cn/ms-unknown/2020/03/23/930393d9b18e5e36199f1987db4ec36d/w192_h72.png"
};
const taskStyleConfig = {
  show: false,
  taskFinishBtnImage: "https://sss.qtfm.cn/qt-member-draw/sources/finish.png",
  taskDoBtnImage: "https://sss.qtfm.cn/qt-member-draw/sources/unfinish.png",
  backgroundColor: "#bc18a7",
  taskTitleColor: "#ffffff",
  taskDescColor: "#ffd7c9"
};
const prizeStyleConfig = {
  show: false,
  prizeTitle: "奖品预览",
  prizeTitleColor: "#fbeebf",
  prizeBg: "#ca9e61",
  prizeBgImg: "",
  prizeItemBg: "#fae5b1"
};
const imageConfig__32 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/69b3bf47548b346ee41a17c440c6fe94.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__32 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__33 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "relative",
  "zIndex": 2
};
const swiperConfig = {
  loop: true,
  autoplay: true,
  delay: 1000,
  direction: "horizontal",
  slidesPerView: 1,
  sideOpenMask: false,
  sideScale: false
};
const swiperStyle = {
  "width": "100%",
  "position": "",
  "marginTop": 0
};
const imageConfig__35 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/991b0a3e9af6dfd8c65d8b98602044cd.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__35 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__36 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/2b76163a0a65065356f258d5a9e6f8e7.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__36 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__37 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/0e7d6ee8e10bd6420aa1cb6c8702e16b.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__37 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__38 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/c89bf85ceabbf2135e675fb842ff07f5.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__38 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__39 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/145bab429ff5022b063fa5d7eadd5fbd.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__39 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__40 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/97d2d078d36f44c1110182e1be725e3c.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__40 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__41 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const imageConfig__42 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/a4a3cfabf3aa3827694c8999ffd53626.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__42 = {
  "marginLeft": "auto",
  "marginRight": "auto",
  "position": "absolute",
  "width": "95%",
  "left": 0,
  "right": 0,
  "zIndex": 1,
  "boxSizing": "border-box",
  "marginTop": "-0.5rem"
};
const tabNavsConfig = {
  defaultIndex: 0,
  tabCache: true,
  fixedTop: false,
  tabNavs: [{
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/466205ee3f8a381c31499aab37d98a88.png",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/20550dbda091a3b924c219602c2de728.png"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/3e159b2abce9674d752d5b0b0589bf82.png",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/38d03d56404c8b3c1b16fe315e99a444.png"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/241af486d28719013d10c3b24a8f97b7.png",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/99638d3a36e8c7fe505c5915206ae459.png"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/5bfa428728fc87d8463d3f175cdaa891.gif",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/e36c747e1733217c6cdb6818f4e58a7e.gif"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/c9f6983225d26a86bb59eb712ea4ca55.gif",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/ffb2a66aef17e4bc25db318096395f6e.gif"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/ee258ca38392784be6f5cd7a2a85e83e.png",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/60c8315ba32d9b4085691adcb8030a7c.png"
  }]
};
const tabNavsStyle = {
  navsStyle: {
    "zIndex": 2,
    "width": "95%",
    "backgroundColor": "rgba(44, 62, 143, 0)",
    "height": "0.6rem",
    "position": "relative",
    "left": 0,
    "right": 0,
    "marginLeft": "auto",
    "marginRight": "auto"
  },
  navItemStyle: {
    "width": "16.66%",
    "textAlign": "center",
    "color": "white",
    "lineHeight": 1,
    "backgroundSize": "100% 100%",
    "height": "100%"
  },
  navItemActiveStyle: {
    "width": "16.66%",
    "textAlign": "center",
    "color": "red",
    "lineHeight": 1,
    "backgroundColor": "rgba(46, 165, 41, 0.01)",
    "backgroundSize": "100% 100%",
    "height": "100%"
  }
};
const baseLayoutStyle__44 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const hotZoneConfig = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/555125e7f09dc2525149923b95d5f7d6.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=3c11e390cef552b60e117282c5b9efd0",
    linkOutApp: "https://m.qtfm.cn/podcasters/3c11e390cef552b60e117282c5b9efd0/",
    openNewWebview: false,
    left: 0.0505,
    top: 0.0104,
    width: 0.2508,
    height: 0.445
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/441278",
    linkOutApp: "https://lkme.cc/qfD/6UuYqR2DU?uid=7020311309189197",
    openNewWebview: false,
    left: 0.3012,
    top: 0.0362,
    width: 0.3254,
    height: 0.2154
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/354491",
    linkOutApp: "https://lkme.cc/qfD/7fsP5SEwO?uid=7020311867031604",
    openNewWebview: false,
    left: 0.6415,
    top: 0.0391,
    width: 0.3105,
    height: 0.2096
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/401209",
    linkOutApp: "https://lkme.cc/qfD/lZhMaXtLR?uid=7020312634589255",
    openNewWebview: false,
    left: 0.3102,
    top: 0.2659,
    width: 0.3224,
    height: 0.1924
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=61d753ff6f1d6762ce19d25da56364fc",
    linkOutApp: "https://m.qtfm.cn/podcasters/61d753ff6f1d6762ce19d25da56364fc/",
    openNewWebview: false,
    left: 0.0475,
    top: 0.5357,
    width: 0.2448,
    height: 0.4335
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/337694",
    linkOutApp: "https://lkme.cc/qfD/Fblsi4LrP?uid=7020315105034314",
    openNewWebview: false,
    left: 0.3012,
    top: 0.5357,
    width: 0.3135,
    height: 0.2182
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/363340",
    linkOutApp: "https://lkme.cc/qfD/LR2nez6pP?uid=7020315826454584",
    openNewWebview: false,
    left: 0.6326,
    top: 0.5329,
    width: 0.3374,
    height: 0.2182
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/255738",
    linkOutApp: "https://lkme.cc/qfD/c0csQIFTP?uid=7020316694675505",
    openNewWebview: false,
    left: 0.2983,
    top: 0.7683,
    width: 0.3314,
    height: 0.2067
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/235891",
    linkOutApp: "https://lkme.cc/qfD/EMENsCBKP?uid=7020319060262989",
    openNewWebview: false,
    left: 0.6445,
    top: 0.7683,
    width: 0.3015,
    height: 0.201
  }]
};
const hotZoneStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__46 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/9ec0054df54924a8c3172561f8837578.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=f816b8eb62abd1be1357ee1c6d5df629",
    linkOutApp: "https://m.qtfm.cn/podcasters/f816b8eb62abd1be1357ee1c6d5df629/",
    openNewWebview: false,
    left: 0.0508,
    top: 0.5306,
    width: 0.2418,
    height: 0.419
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/424423",
    linkOutApp: "https://lkme.cc/qfD/vDUfsGZRT?uid=7020356892885023",
    openNewWebview: false,
    left: 0.3045,
    top: 0.5496,
    width: 0.3105,
    height: 0.1959
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/297486",
    linkOutApp: "https://lkme.cc/qfD/Wj0ukbLpP?uid=7020357182292046",
    openNewWebview: false,
    left: 0.6269,
    top: 0.5469,
    width: 0.3135,
    height: 0.1987
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/222062",
    linkOutApp: "https://lkme.cc/qfD/lT2TKOQBP?uid=7020357614305337",
    openNewWebview: false,
    left: 0.3015,
    top: 0.7591,
    width: 0.3224,
    height: 0.1905
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=f2ddc69c3067cd975130d72228409eed",
    linkOutApp: "https://m.qtfm.cn/podcasters/f2ddc69c3067cd975130d72228409eed/",
    openNewWebview: false,
    left: 0.0445,
    top: 0.043,
    width: 0.2418,
    height: 0.419
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/421100",
    linkOutApp: "https://lkme.cc/qfD/uAS6mFYoS?uid=7020362836213776",
    openNewWebview: false,
    left: 0.3102,
    top: 0.0512,
    width: 0.3015,
    height: 0.2068
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/330423",
    linkOutApp: "https://lkme.cc/qfD/1mvv0EV1W?uid=7020361741500453",
    openNewWebview: false,
    left: 0.6236,
    top: 0.0485,
    width: 0.3284,
    height: 0.2068
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/330424",
    linkOutApp: "https://lkme.cc/qfD/tWTcQ0V1W?uid=7020363356307510",
    openNewWebview: false,
    left: 0.3102,
    top: 0.2716,
    width: 0.3105,
    height: 0.1932
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/330453",
    linkOutApp: "https://lkme.cc/qfD/244KQRV1W?uid=7020363859623978",
    openNewWebview: false,
    left: 0.6296,
    top: 0.277,
    width: 0.3165,
    height: 0.1823
  }]
};
const hotZoneStyle__46 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__47 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const hotZoneConfig__48 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/b00db4cd2bdc7e871fcedf005294c200.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=8f81a4e663f7433ba90b58188fc9f6d3",
    linkOutApp: "https://m.qtfm.cn/podcasters/8f81a4e663f7433ba90b58188fc9f6d3/",
    openNewWebview: false,
    left: 0.0445,
    top: 0.032,
    width: 0.2508,
    height: 0.4202
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/431180",
    linkOutApp: "https://lkme.cc/qfD/e9bNwQq7U?uid=7020367781298229",
    openNewWebview: false,
    left: 0.3072,
    top: 0.032,
    width: 0.3165,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/431046",
    linkOutApp: "https://lkme.cc/qfD/BfrBBWV1W?uid=7020368070705162",
    openNewWebview: false,
    left: 0.6386,
    top: 0.032,
    width: 0.3105,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/431022",
    linkOutApp: "https://lkme.cc/qfD/a1akLWV1W?uid=7020368368500757",
    openNewWebview: false,
    left: 0.3132,
    top: 0.2561,
    width: 0.3105,
    height: 0.1961
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/431941",
    linkOutApp: "https://lkme.cc/qfD/sn6FwWV1W?uid=7020368909565980",
    openNewWebview: false,
    left: 0.6356,
    top: 0.2645,
    width: 0.3284,
    height: 0.1877
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=8f81a4e663f7433ba90b58188fc9f6d3",
    linkOutApp: "https://m.qtfm.cn/podcasters/8f81a4e663f7433ba90b58188fc9f6d3/",
    openNewWebview: false,
    left: 0.0535,
    top: 0.5138,
    width: 0.2448,
    height: 0.4426
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/5142967",
    linkOutApp: "https://lkme.cc/qfD/zQTeEPV5T?uid=7020371157712944",
    openNewWebview: false,
    left: 0.3072,
    top: 0.5334,
    width: 0.3224,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/5142975",
    linkOutApp: "https://lkme.cc/qfD/F1wkoOV5T?uid=7020371476480008",
    openNewWebview: false,
    left: 0.6415,
    top: 0.5306,
    width: 0.3045,
    height: 0.2101
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/242594",
    linkOutApp: "https://lkme.cc/qfD/kA7S6TToS?uid=7020372046905378",
    openNewWebview: false,
    left: 0.3012,
    top: 0.7574,
    width: 0.3254,
    height: 0.1989
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/5142784",
    linkOutApp: "https://lkme.cc/qfD/qSJqgaV1W?uid=7020372348895288",
    openNewWebview: false,
    left: 0.6415,
    top: 0.7574,
    width: 0.3195,
    height: 0.1989
  }]
};
const hotZoneStyle__48 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__49 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/1f76abde79a334426e2e460a4c600ce0.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=8f81a4e663f7433ba90b58188fc9f6d3",
    linkOutApp: "https://m.qtfm.cn/podcasters/8f81a4e663f7433ba90b58188fc9f6d3/",
    openNewWebview: false,
    left: 0.0505,
    top: 0.0159,
    width: 0.2448,
    height: 0.4437
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/433021",
    linkOutApp: "https://lkme.cc/qfD/vfLXbeV1W?uid=7020377549832196",
    openNewWebview: false,
    left: 0.3072,
    top: 0.0187,
    width: 0.3075,
    height: 0.2233
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/432707",
    linkOutApp: "https://lkme.cc/qfD/fvVazhV1W?uid=7020379026227238",
    openNewWebview: false,
    left: 0.6296,
    top: 0.0102,
    width: 0.3433,
    height: 0.2374
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/433047",
    linkOutApp: "https://lkme.cc/qfD/dtbhPiV1W?uid=7020379475017743",
    openNewWebview: false,
    left: 0.3042,
    top: 0.2504,
    width: 0.3075,
    height: 0.2091
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/432680",
    linkOutApp: "https://lkme.cc/qfD/248SBjV1W?uid=7020379982528544",
    openNewWebview: false,
    left: 0.6386,
    top: 0.2589,
    width: 0.3314,
    height: 0.2007
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=79ceafe3e9f1f4145e21f24799d5a088",
    linkOutApp: "https://m.qtfm.cn/podcasters/79ceafe3e9f1f4145e21f24799d5a088/",
    openNewWebview: false,
    left: 0.0535,
    top: 0.5273,
    width: 0.2418,
    height: 0.4324
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/414154",
    linkOutApp: "https://lkme.cc/qfD/LeuaCFEUT?uid=7020381794467872",
    openNewWebview: false,
    left: 0.3042,
    top: 0.5358,
    width: 0.3224,
    height: 0.2204
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/360691",
    linkOutApp: "https://lkme.cc/qfD/YLsZ2u4TQ?uid=7020382260035649",
    openNewWebview: false,
    left: 0.6415,
    top: 0.5386,
    width: 0.3195,
    height: 0.2148
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/387673",
    linkOutApp: "https://lkme.cc/qfD/cPMmpzcOS?uid=7020382595579945",
    openNewWebview: false,
    left: 0.3102,
    top: 0.7675,
    width: 0.3224,
    height: 0.195
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/406255",
    linkOutApp: "https://lkme.cc/qfD/Xd8A7mV1W?uid=7020382918541410",
    openNewWebview: false,
    left: 0.6415,
    top: 0.7703,
    width: 0.3195,
    height: 0.1978
  }]
};
const hotZoneStyle__49 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__50 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/667e3a224becbcc4ed34f20dd9f97a4b.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=09596729c78342d39397c7c3161810e2",
    linkOutApp: "https://m.qtfm.cn/podcasters/09596729c78342d39397c7c3161810e2/",
    openNewWebview: false,
    left: 0.0403,
    top: 0.0133,
    width: 0.2508,
    height: 0.4203
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/423832",
    linkOutApp: "https://lkme.cc/qfD/mh9r5Sq7U?uid=7020387393863689",
    openNewWebview: false,
    left: 0.306,
    top: 0.0106,
    width: 0.3075,
    height: 0.2102
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/417464",
    linkOutApp: "https://lkme.cc/qfD/PWx8YrV1W?uid=7020387783934020",
    openNewWebview: false,
    left: 0.6356,
    top: 0.0133,
    width: 0.3165,
    height: 0.1991
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/411554",
    linkOutApp: "https://lkme.cc/qfD/HtEisrV1W?uid=7020388085923898",
    openNewWebview: false,
    left: 0.3042,
    top: 0.24,
    width: 0.3165,
    height: 0.1908
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=e7b27d2c17444a7da77ad32800a303c2",
    linkOutApp: "https://m.qtfm.cn/podcasters/e7b27d2c17444a7da77ad32800a303c2/",
    openNewWebview: false,
    left: 0.0445,
    top: 0.511,
    width: 0.1195,
    height: 0.4424
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/435379",
    linkOutApp: "https://lkme.cc/qfD/ebPwltV1W?uid=7020389809782823",
    openNewWebview: false,
    left: 0.3072,
    top: 0.511,
    width: 0.3224,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/420480",
    linkOutApp: "https://lkme.cc/qfD/TLAjXOV5T?uid=7020390212435987",
    openNewWebview: false,
    left: 0.6415,
    top: 0.5138,
    width: 0.3224,
    height: 0.2157
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/418647",
    linkOutApp: "https://lkme.cc/qfD/TnaFPPV5T?uid=7020390698975265",
    openNewWebview: false,
    left: 0.3102,
    top: 0.7405,
    width: 0.3045,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/418649",
    linkOutApp: "https://lkme.cc/qfD/kwVsyuV1W?uid=7020390938050592",
    openNewWebview: false,
    left: 0.6386,
    top: 0.746,
    width: 0.3254,
    height: 0.2074
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=2ecb22d7835f4b37a0b6e2958ce050bd",
    linkOutApp: "https://m.qtfm.cn/podcasters/2ecb22d7835f4b37a0b6e2958ce050bd/",
    openNewWebview: false,
    left: 0.158,
    top: 0.5071,
    width: 0.1284,
    height: 0.448
  }]
};
const hotZoneStyle__50 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__51 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const hotZoneConfig__52 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/0aaace95ded48d8dfec11f99775ebd7c.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=488dfd57c8d556afdbe62534d3453729",
    linkOutApp: "https://m.qtfm.cn/podcasters/488dfd57c8d556afdbe62534d3453729/",
    openNewWebview: false,
    left: 0.0433,
    top: 0.035,
    width: 0.2418,
    height: 0.9187
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/439585",
    linkOutApp: "https://lkme.cc/qfD/IYj2fO5FU?uid=7020394138304589",
    openNewWebview: false,
    left: 0.2941,
    top: 0.0688,
    width: 0.3224,
    height: 0.4453
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/426379",
    linkOutApp: "https://lkme.cc/qfD/4tHXzyV1W?uid=7020394591289411",
    openNewWebview: false,
    left: 0.6224,
    top: 0.0632,
    width: 0.3284,
    height: 0.4622
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/156568",
    linkOutApp: "https://lkme.cc/qfD/goQNNzV1W?uid=7020394960388099",
    openNewWebview: false,
    left: 0.2971,
    top: 0.5423,
    width: 0.3344,
    height: 0.4397
  }]
};
const hotZoneStyle__52 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__53 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/6fbb4d701c9710a06215ba138bfc9b50.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=6f8086c15775a85ed71e77ead3dd292b",
    linkOutApp: "https://m.qtfm.cn/podcasters/6f8086c15775a85ed71e77ead3dd292b/",
    openNewWebview: false,
    left: 0.0418,
    top: 0.0352,
    width: 0.412,
    height: 0.2325
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/449721",
    linkOutApp: "https://lkme.cc/qfD/w0Uy2tW1W?uid=7020446067982370",
    openNewWebview: false,
    left: 0.0448,
    top: 0.2757,
    width: 0.4209,
    height: 0.1946
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=991f525453fe40ef8d4f74a3bfb1c2b8",
    linkOutApp: "https://m.qtfm.cn/podcasters/991f525453fe40ef8d4f74a3bfb1c2b8/",
    openNewWebview: false,
    left: 0.5105,
    top: 0.0298,
    width: 0.4209,
    height: 0.2352
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/402683",
    linkOutApp: "https://lkme.cc/qfD/usQDf35ET?uid=7020399288909851",
    openNewWebview: false,
    left: 0.5105,
    top: 0.2703,
    width: 0.415,
    height: 0.2
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=d909a1b7be614d3682674da08b1d4627",
    linkOutApp: "https://m.qtfm.cn/podcasters/d909a1b7be614d3682674da08b1d4627/",
    openNewWebview: false,
    left: 0.0418,
    top: 0.5054,
    width: 0.418,
    height: 0.2622
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/429396",
    linkOutApp: "https://lkme.cc/qfD/iiNf2kZ5T?uid=7020400635281420",
    openNewWebview: false,
    left: 0.0448,
    top: 0.7756,
    width: 0.409,
    height: 0.1919
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=0c58fc5528414095865034efe7e7a6e3",
    linkOutApp: "https://m.qtfm.cn/podcasters/0c58fc5528414095865034efe7e7a6e3/",
    openNewWebview: false,
    left: 0.5195,
    top: 0.5081,
    width: 0.409,
    height: 0.2514
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/387255",
    linkOutApp: "https://lkme.cc/qfD/aOSoD7IFT?uid=7020402866651156",
    openNewWebview: false,
    left: 0.5165,
    top: 0.7675,
    width: 0.412,
    height: 0.1919
  }]
};
const hotZoneStyle__53 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__54 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const hotZoneConfig__55 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/2b451c066c4ce6048f2212e93443c3bc.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/400988",
    linkOutApp: "https://lkme.cc/qfD/OnCV88eKR?uid=7020408453464078",
    openNewWebview: false,
    left: 0.306,
    top: 0.0197,
    width: 0.3165,
    height: 0.2269
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/401197",
    linkOutApp: "https://lkme.cc/qfD/tqPer6W1W?uid=7020409153912869",
    openNewWebview: false,
    left: 0.6344,
    top: 0.0197,
    width: 0.3344,
    height: 0.2241
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/401198",
    linkOutApp: "https://lkme.cc/qfD/ZIHd87W1W?uid=7020409992773657",
    openNewWebview: false,
    left: 0.3102,
    top: 0.2521,
    width: 0.3224,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/401196",
    linkOutApp: "https://lkme.cc/qfD/EZrUI8W1W?uid=7020410483507234",
    openNewWebview: false,
    left: 0.6415,
    top: 0.2521,
    width: 0.3195,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/434546",
    linkOutApp: "https://lkme.cc/qfD/RUp779W1W?uid=7020411334950915",
    openNewWebview: false,
    left: 0.3072,
    top: 0.5266,
    width: 0.3195,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/300138",
    linkOutApp: "https://lkme.cc/qfD/zjS8v9W1W?uid=7020411959902254",
    openNewWebview: false,
    left: 0.6415,
    top: 0.5266,
    width: 0.3224,
    height: 0.2101
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/300165",
    linkOutApp: "https://lkme.cc/qfD/ZuVjWIW1W?uid=7020412509356039",
    openNewWebview: false,
    left: 0.2983,
    top: 0.7602,
    width: 0.3254,
    height: 0.2017
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/300097",
    linkOutApp: "https://lkme.cc/qfD/wspJqIW1W?uid=7020412781985944",
    openNewWebview: false,
    left: 0.6445,
    top: 0.7602,
    width: 0.3284,
    height: 0.2101
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=6e26cb029330335a48dfab3aa452ba58",
    linkOutApp: "https://m.qtfm.cn/podcasters/6e26cb029330335a48dfab3aa452ba58/",
    openNewWebview: false,
    left: 0.0415,
    top: 0.511,
    width: 0.2478,
    height: 0.4566
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=9f7765cf9e47e1deae7242a7ddc852e1",
    linkOutApp: "https://m.qtfm.cn/podcasters/9f7765cf9e47e1deae7242a7ddc852e1/",
    openNewWebview: false,
    left: 0.0326,
    top: 0.0068,
    width: 0.2657,
    height: 0.4566
  }]
};
const hotZoneStyle__55 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__56 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/92eab2ff39381438095ed67a4bc4fbce.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/406094",
    linkOutApp: "https://lkme.cc/qfD/6dBfNPW1W?uid=7020418771451920",
    openNewWebview: false,
    left: 0.309,
    top: 0.0221,
    width: 0.3314,
    height: 0.2289
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/406092",
    linkOutApp: "https://lkme.cc/qfD/7pkXfPW1W?uid=7020419056664582",
    openNewWebview: false,
    left: 0.6463,
    top: 0.0277,
    width: 0.3165,
    height: 0.2261
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/406090",
    linkOutApp: "https://lkme.cc/qfD/1dgZwPW1W?uid=7020419304128541",
    openNewWebview: false,
    left: 0.3072,
    top: 0.2623,
    width: 0.3284,
    height: 0.2091
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/406096",
    linkOutApp: "https://lkme.cc/qfD/0enQIQW1W?uid=7020419627089940",
    openNewWebview: false,
    left: 0.6475,
    top: 0.2651,
    width: 0.3195,
    height: 0.212
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/232389",
    linkOutApp: "https://lkme.cc/qfD/Wuz0OdyUU?uid=7020422072369199",
    openNewWebview: false,
    left: 0.3102,
    top: 0.5465,
    width: 0.3195,
    height: 0.2063
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/266602",
    linkOutApp: "https://lkme.cc/qfD/8zQP5UW1W?uid=7020423217414222",
    openNewWebview: false,
    left: 0.6386,
    top: 0.5409,
    width: 0.3195,
    height: 0.2148
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/229990",
    linkOutApp: "https://lkme.cc/qfD/zcr8uUW1W?uid=7020423833976885",
    openNewWebview: false,
    left: 0.3042,
    top: 0.7669,
    width: 0.3224,
    height: 0.2035
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/228730",
    linkOutApp: "https://lkme.cc/qfD/UlLwMVW1W?uid=7020424257601562",
    openNewWebview: false,
    left: 0.6415,
    top: 0.7697,
    width: 0.3254,
    height: 0.2035
  }]
};
const hotZoneStyle__56 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__57 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/6a5cce8e1c3e2348d34ea8d269adbbe0.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/406487",
    linkOutApp: "https://lkme.cc/qfD/aW7yOXW1W?uid=7020426132455435",
    openNewWebview: false,
    left: 0.312,
    top: 0.005,
    width: 0.3165,
    height: 0.2157
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/413282",
    linkOutApp: "https://lkme.cc/qfD/LgEyGYW1W?uid=7020426790961184",
    openNewWebview: false,
    left: 0.6374,
    top: 0.0078,
    width: 0.3224,
    height: 0.2185
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/410896",
    linkOutApp: "https://lkme.cc/qfD/0LxlaYW1W?uid=7020427222974489",
    openNewWebview: false,
    left: 0.3042,
    top: 0.2345,
    width: 0.3254,
    height: 0.2074
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/414934",
    linkOutApp: "https://lkme.cc/qfD/6dNDJZW1W?uid=7020427877285909",
    openNewWebview: false,
    left: 0.6475,
    top: 0.2317,
    width: 0.3105,
    height: 0.2074
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/239839",
    linkOutApp: "https://lkme.cc/qfD/YIG8pIYXP?uid=7020429458538534",
    openNewWebview: false,
    left: 0.3072,
    top: 0.5193,
    width: 0.3224,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/239845",
    linkOutApp: "https://lkme.cc/qfD/Vg0DXdW1W?uid=7020431757017096",
    openNewWebview: false,
    left: 0.6386,
    top: 0.5221,
    width: 0.3344,
    height: 0.2157
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/266319",
    linkOutApp: "https://lkme.cc/qfD/90qBwdW1W?uid=7020432109338668",
    openNewWebview: false,
    left: 0.3102,
    top: 0.7377,
    width: 0.3075,
    height: 0.2212
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/265834",
    linkOutApp: "https://lkme.cc/qfD/TXkjIeW1W?uid=7020432444883022",
    openNewWebview: false,
    left: 0.6386,
    top: 0.7516,
    width: 0.3374,
    height: 0.2074
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=4de19251e40cf6cc616c5317aa9216e5",
    linkOutApp: "https://m.qtfm.cn/podcasters/4de19251e40cf6cc616c5317aa9216e5/",
    openNewWebview: false,
    left: 0.0445,
    top: 0.0083,
    width: 0.2508,
    height: 0.4341
  }]
};
const hotZoneStyle__57 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__58 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const hotZoneConfig__59 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/56409dbc5ad8af98206ec5eabf014891.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455732",
    linkOutApp: "https://lkme.cc/qfD/aOIh4JPdV?uid=7020434961465388",
    openNewWebview: false,
    left: 0.2911,
    top: 0.0309,
    width: 0.3374,
    height: 0.2073
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/383340",
    linkOutApp: "https://lkme.cc/qfD/i27v2XUUQ?uid=7020435326369807",
    openNewWebview: false,
    left: 0.6403,
    top: 0.0225,
    width: 0.3254,
    height: 0.2269
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/349701",
    linkOutApp: "https://lkme.cc/qfD/w0JiDpWXP?uid=7020435699662920",
    openNewWebview: false,
    left: 0.303,
    top: 0.2437,
    width: 0.3195,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/383338",
    linkOutApp: "https://lkme.cc/qfD/mFZXIiW1W?uid=7020436119093250",
    openNewWebview: false,
    left: 0.6415,
    top: 0.2577,
    width: 0.3165,
    height: 0.2101
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/294280",
    linkOutApp: "https://lkme.cc/qfD/WAsfyPJ6P?uid=7020437054423061",
    openNewWebview: false,
    left: 0.3042,
    top: 0.5418,
    width: 0.3135,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/324440",
    linkOutApp: "https://lkme.cc/qfD/bGqfX37pP?uid=7020437826174981",
    openNewWebview: false,
    left: 0.6326,
    top: 0.5362,
    width: 0.3195,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/320551",
    linkOutApp: "https://lkme.cc/qfD/8DFtuhZsP?uid=7020438195273751",
    openNewWebview: false,
    left: 0.2953,
    top: 0.7602,
    width: 0.3344,
    height: 0.1961
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/294765",
    linkOutApp: "https://lkme.cc/qfD/qUaZUwSbT?uid=7020438652452902",
    openNewWebview: false,
    left: 0.6415,
    top: 0.7602,
    width: 0.3344,
    height: 0.2045
  }]
};
const hotZoneStyle__59 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__60 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/90994084ae3198bc4e63047d78ac8ad2.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/405914",
    linkOutApp: "https://lkme.cc/qfD/ChjTvq3kR?uid=7020441231949889",
    openNewWebview: false,
    left: 0.2911,
    top: 0.0249,
    width: 0.3374,
    height: 0.2204
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/434455",
    linkOutApp: "https://lkme.cc/qfD/li5Dvmm5U?uid=7020441684934665",
    openNewWebview: false,
    left: 0.6374,
    top: 0.0277,
    width: 0.3254,
    height: 0.2233
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/340451",
    linkOutApp: "https://lkme.cc/qfD/opkspoW1W?uid=7020442104365059",
    openNewWebview: false,
    left: 0.2941,
    top: 0.2594,
    width: 0.3224,
    height: 0.2148
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/264801",
    linkOutApp: "https://lkme.cc/qfD/ff7i7pW1W?uid=7020442473463901",
    openNewWebview: false,
    left: 0.6356,
    top: 0.2623,
    width: 0.3284,
    height: 0.2148
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=8bb9fc52565eb0ccca099cc74d536d54",
    linkOutApp: "https://m.qtfm.cn/podcasters/8bb9fc52565eb0ccca099cc74d536d54/",
    openNewWebview: false,
    left: 0.0326,
    top: 0.0142,
    width: 0.2508,
    height: 0.4663
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/420096",
    linkOutApp: "https://lkme.cc/qfD/elyBtlIjT?uid=7020443870167120",
    openNewWebview: false,
    left: 0.3042,
    top: 0.5409,
    width: 0.3105,
    height: 0.212
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/452493",
    linkOutApp: "https://lkme.cc/qfD/azYc6rW1W?uid=7020444302180389",
    openNewWebview: false,
    left: 0.6296,
    top: 0.538,
    width: 0.3314,
    height: 0.2176
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/423150",
    linkOutApp: "https://lkme.cc/qfD/TQ49agY7T?uid=7020444822274077",
    openNewWebview: false,
    left: 0.3042,
    top: 0.7669,
    width: 0.3165,
    height: 0.2091
  }]
};
const hotZoneStyle__60 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__61 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/57943b8c0506a5c4581085b5617b802d.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/265713",
    linkOutApp: "https://lkme.cc/qfD/oMHgBl0rV?uid=7020447523405859",
    openNewWebview: false,
    left: 0.2911,
    top: 0.0079,
    width: 0.3195,
    height: 0.2191
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/281294",
    linkOutApp: "https://lkme.cc/qfD/gEiyL8YXP?uid=7020450090319969",
    openNewWebview: false,
    left: 0.6224,
    top: 0.0079,
    width: 0.3403,
    height: 0.2191
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/281290",
    linkOutApp: "https://lkme.cc/qfD/ABV915YXP?uid=7020450564276238",
    openNewWebview: false,
    left: 0.2941,
    top: 0.2382,
    width: 0.3224,
    height: 0.2051
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/269210",
    linkOutApp: "https://lkme.cc/qfD/To2Ku8YXP?uid=7020451013066807",
    openNewWebview: false,
    left: 0.6326,
    top: 0.2326,
    width: 0.3195,
    height: 0.2079
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=40a7695e641e47de64a52e7c81fe642f",
    linkOutApp: "https://m.qtfm.cn/podcasters/40a7695e641e47de64a52e7c81fe642f/",
    openNewWebview: false,
    left: 0.0326,
    top: 0.0096,
    width: 0.2538,
    height: 0.4269
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/440597",
    linkOutApp: "https://lkme.cc/qfD/HQQVyMZJV?uid=7020453546426417",
    openNewWebview: false,
    left: 0.3072,
    top: 0.5218,
    width: 0.3075,
    height: 0.2135
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/408586",
    linkOutApp: "https://lkme.cc/qfD/BHxjpBX1W?uid=7020454016188431",
    openNewWebview: false,
    left: 0.6296,
    top: 0.519,
    width: 0.3195,
    height: 0.2135
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/408585",
    linkOutApp: "https://lkme.cc/qfD/z9ILxjaAS?uid=7020454368510015",
    openNewWebview: false,
    left: 0.3042,
    top: 0.7465,
    width: 0.3105,
    height: 0.2135
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/440805",
    linkOutApp: "https://lkme.cc/qfD/ZWkpeCX1W?uid=7020454838272049",
    openNewWebview: false,
    left: 0.6326,
    top: 0.7493,
    width: 0.3135,
    height: 0.2135
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=b0562c270a4d6878598b67b9ba363dcb",
    linkOutApp: "https://m.qtfm.cn/podcasters/b0562c270a4d6878598b67b9ba363dcb/",
    openNewWebview: false,
    left: 0.0326,
    top: 0.5162,
    width: 0.2508,
    height: 0.4381
  }]
};
const hotZoneStyle__61 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__62 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/b056196b73f886dee903fbb35f01bb90.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455807",
    linkOutApp: "https://lkme.cc/qfD/mpmv8eSnV?uid=7020456654405662",
    openNewWebview: false,
    left: 0.303,
    top: 0.0322,
    width: 0.3195,
    height: 0.4107
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/355478",
    linkOutApp: "https://lkme.cc/qfD/pBtXifBkP?uid=7020456989950026",
    openNewWebview: false,
    left: 0.6314,
    top: 0.0267,
    width: 0.3224,
    height: 0.4162
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/321418",
    linkOutApp: "https://lkme.cc/qfD/UtifZGVUQ?uid=7020457287745561",
    openNewWebview: false,
    left: 0.3,
    top: 0.4817,
    width: 0.3165,
    height: 0.3996
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455778",
    linkOutApp: "https://lkme.cc/qfD/g8k5vFX1W?uid=7020457757507635",
    openNewWebview: false,
    left: 0.6403,
    top: 0.4762,
    width: 0.3105,
    height: 0.4218
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=cfc6ef1548ac4b2292477a5fd49bf5e5",
    linkOutApp: "https://m.qtfm.cn/podcasters/cfc6ef1548ac4b2292477a5fd49bf5e5/",
    openNewWebview: false,
    left: 0.0296,
    top: 0.0078,
    width: 0.2508,
    height: 0.8712
  }]
};
const hotZoneStyle__62 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__63 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const hotZoneConfig__64 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/7c5ba55b69ce79b76398c09257086a2c.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/236126",
    linkOutApp: "https://lkme.cc/qfD/ybmitWi8P?uid=7020459607195694",
    openNewWebview: false,
    left: 0.306,
    top: 0.0415,
    width: 0.3105,
    height: 0.1961
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/353879",
    linkOutApp: "https://lkme.cc/qfD/KGsSBzJZP?uid=7020459921768489",
    openNewWebview: false,
    left: 0.6254,
    top: 0.0359,
    width: 0.3314,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/325006",
    linkOutApp: "https://lkme.cc/qfD/wnfJCZJZP?uid=7020460206981159",
    openNewWebview: false,
    left: 0.306,
    top: 0.2488,
    width: 0.3105,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/367862",
    linkOutApp: "https://lkme.cc/qfD/fhg30BfpP?uid=7020460592857109",
    openNewWebview: false,
    left: 0.6266,
    top: 0.2516,
    width: 0.3284,
    height: 0.2045
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=b801fa0cd144df7f770ed75c4aed61f2",
    linkOutApp: "https://m.qtfm.cn/podcasters/b801fa0cd144df7f770ed75c4aed61f2/",
    openNewWebview: false,
    left: 0.0415,
    top: 0.0202,
    width: 0.2478,
    height: 0.4398
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/327015",
    linkOutApp: "https://lkme.cc/qfD/853EIlMKP?uid=7020462945861678",
    openNewWebview: false,
    left: 0.3012,
    top: 0.5283,
    width: 0.3195,
    height: 0.2129
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/345974",
    linkOutApp: "https://lkme.cc/qfD/pze4Dq7pP?uid=7020463226880007",
    openNewWebview: false,
    left: 0.6326,
    top: 0.5227,
    width: 0.3254,
    height: 0.2185
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/375432",
    linkOutApp: "https://lkme.cc/qfD/Bsl7xGbDQ?uid=7020463549841418",
    openNewWebview: false,
    left: 0.2953,
    top: 0.7552,
    width: 0.3224,
    height: 0.1961
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/359494",
    linkOutApp: "https://lkme.cc/qfD/M3wH22P4Q?uid=7020464086712330",
    openNewWebview: false,
    left: 0.6415,
    top: 0.7524,
    width: 0.3105,
    height: 0.2045
  }]
};
const hotZoneStyle__64 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__65 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/ec74049b91de6e77ef698d340306d649.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/412031",
    linkOutApp: "https://lkme.cc/qfD/hhqkBkB5S?uid=7020465877680165",
    openNewWebview: false,
    left: 0.312,
    top: 0.0362,
    width: 0.3105,
    height: 0.2148
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/454451",
    linkOutApp: "https://lkme.cc/qfD/wGdhVbVMV?uid=7020466334859290",
    openNewWebview: false,
    left: 0.6344,
    top: 0.0277,
    width: 0.3344,
    height: 0.2176
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/453516",
    linkOutApp: "https://lkme.cc/qfD/mn1U8ggJV?uid=7020467073056816",
    openNewWebview: false,
    left: 0.3,
    top: 0.2679,
    width: 0.3254,
    height: 0.1894
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/456986",
    linkOutApp: "https://lkme.cc/qfD/bg4BKlPyV?uid=7020467437961297",
    openNewWebview: false,
    left: 0.6415,
    top: 0.2623,
    width: 0.3254,
    height: 0.2035
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/458019",
    linkOutApp: "https://lkme.cc/qfD/uWVOR9X1W?uid=7020468314570782",
    openNewWebview: false,
    left: 0.3012,
    top: 0.5426,
    width: 0.3195,
    height: 0.2035
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/456120",
    linkOutApp: "https://lkme.cc/qfD/Bh41LDPdV?uid=7020468616560684",
    openNewWebview: false,
    left: 0.6386,
    top: 0.5397,
    width: 0.3105,
    height: 0.2091
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/456121",
    linkOutApp: "https://lkme.cc/qfD/gagEE0YaV?uid=7020468947910697",
    openNewWebview: false,
    left: 0.2983,
    top: 0.7686,
    width: 0.3105,
    height: 0.2035
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/456115",
    linkOutApp: "https://lkme.cc/qfD/2EYDZDPdV?uid=7020469287649316",
    openNewWebview: false,
    left: 0.6386,
    top: 0.7686,
    width: 0.3135,
    height: 0.2091
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=e859019e6dfe47b792df82e0d01871c2",
    linkOutApp: "https://m.qtfm.cn/podcasters/e859019e6dfe47b792df82e0d01871c2/",
    openNewWebview: false,
    left: 0.0386,
    top: 0.5228,
    width: 0.2389,
    height: 0.4465
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=ba4d70ade0714b85ae88cf94de360324",
    linkOutApp: "https://m.qtfm.cn/podcasters/ba4d70ade0714b85ae88cf94de360324/",
    openNewWebview: false,
    left: 0.1639,
    top: 0.0859,
    width: 0.1195,
    height: 0.2515
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=9761b8d4f7afe2c22384fff97c67502d",
    linkOutApp: "https://m.qtfm.cn/podcasters/9761b8d4f7afe2c22384fff97c67502d/",
    openNewWebview: false,
    left: 0.0565,
    top: 0.0831,
    width: 0.1045,
    height: 0.2487
  }]
};
const hotZoneStyle__65 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__66 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/b911c807915f8e3d165fb1bc41e3defe.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/240665",
    linkOutApp: "https://lkme.cc/qfD/MQ0gpnzDU?uid=7020472538234937",
    openNewWebview: false,
    left: 0.3,
    top: 0.0135,
    width: 0.3135,
    height: 0.2163
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/240664",
    linkOutApp: "https://lkme.cc/qfD/xQvTim3EU?uid=7020472877973578",
    openNewWebview: false,
    left: 0.6254,
    top: 0.0135,
    width: 0.3284,
    height: 0.2079
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/405932",
    linkOutApp: "https://lkme.cc/qfD/Ac4Q5n3EU?uid=7020473360318481",
    openNewWebview: false,
    left: 0.303,
    top: 0.2438,
    width: 0.3135,
    height: 0.191
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/257064",
    linkOutApp: "https://lkme.cc/qfD/fpAw5E4EU?uid=7020473729417251",
    openNewWebview: false,
    left: 0.6326,
    top: 0.2382,
    width: 0.3135,
    height: 0.1994
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=fc7f937a3fe4378aac14889583db67bb",
    linkOutApp: "https://m.qtfm.cn/podcasters/fc7f937a3fe4378aac14889583db67bb/",
    openNewWebview: false,
    left: 0.0386,
    top: 0.018,
    width: 0.2418,
    height: 0.4157
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/435874",
    linkOutApp: "https://lkme.cc/qfD/Tam8fv8FU?uid=7020475008680014",
    openNewWebview: false,
    left: 0.2923,
    top: 0.5331,
    width: 0.3165,
    height: 0.2079
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/435873",
    linkOutApp: "https://lkme.cc/qfD/PYsNFw8FU?uid=7020475394555928",
    openNewWebview: false,
    left: 0.6386,
    top: 0.5291,
    width: 0.3195,
    height: 0.2079
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/435871",
    linkOutApp: "https://lkme.cc/qfD/1Na39x8FU?uid=7020475612659720",
    openNewWebview: false,
    left: 0.2983,
    top: 0.7538,
    width: 0.3195,
    height: 0.1938
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/330902",
    linkOutApp: "https://lkme.cc/qfD/Wk1uUK8kR?uid=7020476430549049",
    openNewWebview: false,
    left: 0.6356,
    top: 0.7566,
    width: 0.3284,
    height: 0.1938
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=fa9dccc69f2bfbd21b226fd686c30953",
    linkOutApp: "https://m.qtfm.cn/podcasters/fa9dccc69f2bfbd21b226fd686c30953/",
    openNewWebview: false,
    left: 0.0326,
    top: 0.5218,
    width: 0.2478,
    height: 0.4213
  }]
};
const hotZoneStyle__66 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__67 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/5099ef0e5473e4797e4c72c575b48771.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/322287",
    linkOutApp: "https://lkme.cc/qfD/38GKgfrYP?uid=7020477927915560",
    openNewWebview: false,
    left: 0.2941,
    top: 0.0433,
    width: 0.3254,
    height: 0.3885
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/449795",
    linkOutApp: "https://lkme.cc/qfD/O64mRSX1W?uid=7020478397677584",
    openNewWebview: false,
    left: 0.6403,
    top: 0.0433,
    width: 0.3224,
    height: 0.3774
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/449796",
    linkOutApp: "https://lkme.cc/qfD/XwJnkSX1W?uid=7020478678695971",
    openNewWebview: false,
    left: 0.2941,
    top: 0.4595,
    width: 0.3254,
    height: 0.394
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/449798",
    linkOutApp: "https://lkme.cc/qfD/qRNhOGUAW?uid=7020479001657430",
    openNewWebview: false,
    left: 0.6403,
    top: 0.4484,
    width: 0.3374,
    height: 0.4162
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/podcasters?podcasterId=ba0381692eec48dd4b1af9997580fc1f",
    linkOutApp: "https://m.qtfm.cn/podcasters/ba0381692eec48dd4b1af9997580fc1f/",
    openNewWebview: false,
    left: 0.0236,
    top: 0.0189,
    width: 0.2598,
    height: 0.8324
  }]
};
const hotZoneStyle__67 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__68 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/b552a162f5371f8b319f013c64bf1704.jpg",
  openExpose: true,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/460684",
    linkOutApp: "https://m.qtfm.cn/vchannels/460684",
    openNewWebview: false,
    left: 0.1866,
    top: 0.193,
    width: 0.4687,
    height: 0.2671
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/462122",
    linkOutApp: "https://m.qtfm.cn/vchannels/462122",
    openNewWebview: false,
    left: 0.6659,
    top: 0.199,
    width: 0.3075,
    height: 0.3032
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/462121",
    linkOutApp: "https://m.qtfm.cn/vchannels/462121",
    openNewWebview: false,
    left: 0.1883,
    top: 0.4705,
    width: 0.3851,
    height: 0.2334
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/462100",
    linkOutApp: "https://m.qtfm.cn/vchannels/462100",
    openNewWebview: false,
    left: 0.5794,
    top: 0.4956,
    width: 0.3941,
    height: 0.2406
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/462100",
    linkOutApp: "https://m.qtfm.cn/vchannels/462100",
    openNewWebview: false,
    left: 0.1854,
    top: 0.7094,
    width: 0.4508,
    height: 0.2454
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/462123",
    linkOutApp: "https://m.qtfm.cn/vchannels/462123",
    openNewWebview: false,
    left: 0.648,
    top: 0.7417,
    width: 0.3314,
    height: 0.2166
  }]
};
const hotZoneStyle__68 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__69 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const imageConfig__70 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/355c37a5d4c9129eaf26c0c81294cee5.gif",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__70 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const tabNavsConfig__71 = {
  defaultIndex: 0,
  tabCache: true,
  fixedTop: false,
  tabNavs: [{
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/af66d24e56eab1b029fc8b95d5c15f7b.jpg",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/987e15b2ac098f6f393cd057e1748356.jpg"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/9512ff6bd510ac41523c65187e3912da.jpg",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/3865948b3e1f4e1057e2b7f8fb77d014.jpg"
  }, {
    title: "",
    defaultBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/230f7f02f36306bbae16dce8c55165ef.jpg",
    activeBgImage: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/221b481f64b98449965ddd0724d2a78a.jpg"
  }]
};
const tabNavsStyle__71 = {
  navsStyle: {
    "zIndex": 2,
    "width": "100%",
    "backgroundColor": "#2c3e8f",
    "height": "1rem"
  },
  navItemStyle: {
    "width": "33.3333%",
    "textAlign": "center",
    "color": "white",
    "lineHeight": 1,
    "backgroundSize": "100% 100%",
    "height": "1rem"
  },
  navItemActiveStyle: {
    "width": "33.3333%",
    "textAlign": "center",
    "color": "red",
    "lineHeight": 1,
    "backgroundColor": "rgba(46, 165, 41, 0)",
    "backgroundSize": "100% 100%",
    "height": "1rem"
  }
};
const hotZoneConfig__72 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/973b7d12695c81cd0ae7fd861df9f629.gif",
  openExpose: false,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455766",
    linkOutApp: "https://m.qtfm.cn/vchannels/455766",
    openNewWebview: false,
    left: 0.0389,
    top: 0.0039,
    width: 0.2986,
    height: 0.4353
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455748",
    linkOutApp: "https://m.qtfm.cn/vchannels/455748",
    openNewWebview: false,
    left: 0.3433,
    top: 0.0039,
    width: 0.2896,
    height: 0.4391
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455788",
    linkOutApp: "https://m.qtfm.cn/vchannels/455788",
    openNewWebview: false,
    left: 0.6389,
    top: 0.0039,
    width: 0.3135,
    height: 0.4468
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455809",
    linkOutApp: "https://m.qtfm.cn/vchannels/455809",
    openNewWebview: false,
    left: 0.0389,
    top: 0.4584,
    width: 0.3045,
    height: 0.4545
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455838",
    linkOutApp: "https://m.qtfm.cn/vchannels/455838",
    openNewWebview: false,
    left: 0.3493,
    top: 0.4623,
    width: 0.2806,
    height: 0.4391
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455788",
    linkOutApp: "https://m.qtfm.cn/vchannels/455788",
    openNewWebview: false,
    left: 0.6391,
    top: 0.4681,
    width: 0.2956,
    height: 0.4314
  }]
};
const hotZoneStyle__72 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__73 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/c9872972c221280d16c8f9c025d553b2.gif",
  openExpose: false,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455764",
    linkOutApp: "https://m.qtfm.cn/vchannels/455764",
    openNewWebview: false,
    left: 0.0463,
    top: 0.0162,
    width: 0.2956,
    height: 0.4314
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455771",
    linkOutApp: "https://m.qtfm.cn/vchannels/455771",
    openNewWebview: false,
    left: 0.3495,
    top: 0.0128,
    width: 0.2926,
    height: 0.4314
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455759",
    linkOutApp: "https://m.qtfm.cn/vchannels/455759",
    openNewWebview: false,
    left: 0.648,
    top: 0.003,
    width: 0.3075,
    height: 0.4507
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455864",
    linkOutApp: "https://m.qtfm.cn/vchannels/455864",
    openNewWebview: false,
    left: 0.0391,
    top: 0.4646,
    width: 0.2926,
    height: 0.416
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455817",
    linkOutApp: "https://m.qtfm.cn/vchannels/455817",
    openNewWebview: false,
    left: 0.3376,
    top: 0.4664,
    width: 0.3015,
    height: 0.4122
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455816",
    linkOutApp: "https://m.qtfm.cn/vchannels/455816",
    openNewWebview: false,
    left: 0.6451,
    top: 0.4604,
    width: 0.2896,
    height: 0.4276
  }]
};
const hotZoneStyle__73 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const hotZoneConfig__74 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/08d9be1ba1c37c1ccf0e353ceee6b94b.gif",
  openExpose: false,
  zoneList: [{
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/454144",
    linkOutApp: "https://m.qtfm.cn/vchannels/454144",
    openNewWebview: false,
    left: 0.0433,
    top: 0.0162,
    width: 0.2956,
    height: 0.4314
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455775",
    linkOutApp: "https://m.qtfm.cn/vchannels/455775",
    openNewWebview: false,
    left: 0.3495,
    top: 0.0205,
    width: 0.2956,
    height: 0.4314
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455803",
    linkOutApp: "https://m.qtfm.cn/vchannels/455803",
    openNewWebview: false,
    left: 0.657,
    top: 0.0145,
    width: 0.2806,
    height: 0.4314
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455812",
    linkOutApp: "https://m.qtfm.cn/vchannels/455812",
    openNewWebview: false,
    left: 0.0391,
    top: 0.4608,
    width: 0.2896,
    height: 0.4391
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455813",
    linkOutApp: "https://m.qtfm.cn/vchannels/455813",
    openNewWebview: false,
    left: 0.3406,
    top: 0.4664,
    width: 0.2956,
    height: 0.4353
  }, {
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/455866",
    linkOutApp: "https://m.qtfm.cn/vchannels/455866",
    openNewWebview: false,
    left: 0.6421,
    top: 0.472,
    width: 0.2956,
    height: 0.4237
  }]
};
const hotZoneStyle__74 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__75 = {
  textAlign: "left",
  backgroundRepeat: "no-repeat",
  position: "relative"
};
const imageConfig__76 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/c681ecebacf4574b0308bd81ce4f996d.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__76 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const baseLayoutStyle__77 = {
  "textAlign": "left",
  "backgroundRepeat": "no-repeat",
  "position": "absolute",
  "zIndex": 2,
  "width": "6.5rem",
  "marginTop": "-3.3rem",
  "left": "0.5rem"
};
const swiperConfig__78 = {
  loop: true,
  autoplay: true,
  delay: 1000,
  direction: "horizontal",
  slidesPerView: 1,
  sideOpenMask: false,
  sideScale: false
};
const swiperStyle__78 = {
  "width": "100%",
  "position": "",
  "left": 0
};
const imageConfig__79 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/55731560f091afd505bc09a9221870d8.png",
  link: "https://bp.qtfm.cn/topic/64058fa6b25f6a224aac282a/index.html?a=1",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__79 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__80 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/567177319b63c7ea6a0a404cf9fdb525.png",
  link: "https://bp.qtfm.cn/topic/6368b795fded29ca2f94d178/index.html?a=1",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__80 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__81 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/d7798b4d0da6df210ecf0ae48b80e288.png",
  link: "https://bp.qtfm.cn/topic/6307315a07114417df1871b5/index.html?a=1",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__81 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__82 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/e220bf6cb0caa23fbcc8aeaebc22fd36.png",
  link: "https://bp.qtfm.cn/topic/63e0ad92b25f6a224aabc76b/index.html?a=1",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__82 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__83 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/4388fbb6a5180ed4758e354816f81098.png",
  link: "https://bp.qtfm.cn/topic/632ab5ec071144590119305e/index.html?a=1",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__83 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__84 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/2390d735cb1bb97dd75726202da48541.png",
  link: "https://bp.qtfm.cn/topic/634d101b8899ef6adeaa6321/index.html?a=1",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__84 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__85 = {
  src: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/b3be5751e7a4a79b2edfd75097ed54c5.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__85 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
export default (({
  children: children
}) => {
  const pageConfig = {
    title: "蜻蜓FM423听书节限定",
    color: "#333",
    backgroundColor: "#192063",
    backgroundImage: "",
    margin: "",
    padding: ""
  };
  const appShareConfig = {
    shareTitle: "1折买6家会员年卡！",
    shareImg: "https://bp.qtfm.cn/bms/images/6424f037c2277cbfaffb6628/e35155f317e4a844805ec352006e280d.png",
    shareSubTitle: "分享赚钱，好友下单立返10元！",
    shareLink: "",
    isHiddenAppShare: false,
    isHiddenWxShare: false
  };
  const timeConfig = {
    startTime: null,
    endTime: "2023-04-16 23:59:59",
    useServerTime: true,
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    endRedirectUrl: "",
    redirectPromp: "当前活动已结束，自动跳入更多精彩活动"
  };
  return <WrapContainer id="afb" nodeId="d8572d84-b60d-4942-bf11-755b4bde8afb" nodeType="component-container" children={children} pageConfig={pageConfig} appShareConfig={appShareConfig} timeConfig={timeConfig} env={process.env.SITE_ENV}><Image id="eb5" nodeId="d496cc10-71a1-42b2-b5f6-a0bc3fe45eb5" nodeType="image" imageConfig={imageConfig} imageStyle={imageStyle} env={process.env.SITE_ENV}></Image><TimeController id="d5b" nodeId="080ea479-1f8c-4b6f-8fab-83128e448d5b" nodeType="time-controller" timeConfig={timeConfig__2} env={process.env.SITE_ENV} children={children}><BaseLayout id="ab4" nodeId="6f3628db-b5bb-41d0-afe0-cf07c76ffab4" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle} children={children}><Cps id="d82" nodeId="7f73e8b7-a824-4e1d-aadb-5b24fcad1d82" nodeType="cps" env={process.env.SITE_ENV} cpsConfig={cpsConfig} AudioContext={AudioContext} /></BaseLayout><BaseLayout id="d27" nodeId="01cbbaf9-47de-40ef-859c-6e83cfdf1d27" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__5} children={children}><FixedRule id="ce1" nodeId="61bb4cc0-9427-4c56-9146-8d6317494ce1" nodeType="fixed-rule" fixedRuleConfig={fixedRuleConfig} fixedRuleStyle={fixedRuleStyle} /><Image id="cf9" nodeId="49da8c55-2024-45df-9867-706a9398bcf9" nodeType="image" imageConfig={imageConfig__7} imageStyle={imageStyle__7} env={process.env.SITE_ENV}></Image><Image id="e95" nodeId="eeae49ab-b6d5-4847-a615-3c85b42c4e95" nodeType="image" imageConfig={imageConfig__8} imageStyle={imageStyle__8} env={process.env.SITE_ENV}></Image></BaseLayout><BaseLayout id="f81" nodeId="d79d2cbf-bcb3-4cbc-9ac8-685e5d944f81" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__9} children={children}><Image id="e2c" nodeId="4d27c1b7-aa76-41c0-abc4-c8aed8645e2c" nodeType="image" imageConfig={imageConfig__10} imageStyle={imageStyle__10} env={process.env.SITE_ENV}></Image><CountDown id="fae" nodeId="82c9eef7-5390-4419-83a5-62fb8dc3efae" nodeType="countdown" countDownConfig={countDownConfig} countDownStyle={countDownStyle} env={process.env.SITE_ENV} /><BaseLayout id="e67" nodeId="1e6c3d1b-1b23-4702-9f29-1133a2b89e67" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__12} children={children}><ImageModal id="acf" nodeId="3d6afbe0-1851-4999-a955-de573b40dacf" nodeType="image-modal" imageModalConfig={imageModalConfig} imageModalStyle={imageModalStyle} env={process.env.SITE_ENV} /></BaseLayout><MemberController id="cac" nodeId="d9ddb54a-38bd-405f-be1c-a8d661e58cac" nodeType="member-controller" env={process.env.SITE_ENV} autorenewConfig={autorenewConfig} discountConfig={discountConfig} boughtConfig={boughtConfig} vipLevelConfig={vipLevelConfig} couponConfig={couponConfig} children={children}><TaskController id="df3" nodeId="dcd563d5-f973-4bd5-9be7-ee3eaba90df3" nodeType="task-controller" taskConfig={taskConfig} env={process.env.SITE_ENV} children={children}><BaseLayout id="b68" nodeId="f442f2f7-4d7a-49da-9119-743abda25b68" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__16} children={children}><ImageModal id="a50" nodeId="ac450ff0-8cb4-4902-bea7-684cd5031a50" nodeType="image-modal" imageModalConfig={imageModalConfig__17} imageModalStyle={imageModalStyle__17} env={process.env.SITE_ENV} /></BaseLayout></TaskController></MemberController><MemberController id="b66" nodeId="53ffac63-c645-489d-b0d8-dc28b8b3ab66" nodeType="member-controller" env={process.env.SITE_ENV} autorenewConfig={autorenewConfig__18} discountConfig={discountConfig__18} boughtConfig={boughtConfig__18} vipLevelConfig={vipLevelConfig__18} couponConfig={couponConfig__18} children={children}><TaskController id="ad4" nodeId="77a9de02-abcb-4d55-9b54-13ed8bfc7ad4" nodeType="task-controller" taskConfig={taskConfig__19} env={process.env.SITE_ENV} children={children}><BaseLayout id="baf" nodeId="0cb1e62e-f56b-4425-b556-d84cc1452baf" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__20} children={children}><Image id="e47" nodeId="1b2cf8fa-a9c8-4300-b6db-f5f607a84e47" nodeType="image" imageConfig={imageConfig__21} imageStyle={imageStyle__21} env={process.env.SITE_ENV}></Image></BaseLayout></TaskController></MemberController><MemberController id="b52" nodeId="d8fb35ff-07e2-49a8-bb79-06a8bc3d4b52" nodeType="member-controller" env={process.env.SITE_ENV} autorenewConfig={autorenewConfig__22} discountConfig={discountConfig__22} boughtConfig={boughtConfig__22} vipLevelConfig={vipLevelConfig__22} couponConfig={couponConfig__22} children={children}><TaskController id="d1c" nodeId="9ba8a03d-382a-4d24-a19f-4f2daa1edd1c" nodeType="task-controller" taskConfig={taskConfig__23} env={process.env.SITE_ENV} children={children}><BaseLayout id="cae" nodeId="2284eaa1-6848-47d6-90e6-7e866e3f8cae" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__24} children={children}><ReceiveTask id="be1" nodeId="195eadd8-647f-4687-93eb-e7d3019e6be1" nodeType="receive-task" env={process.env.SITE_ENV} taskConfig={taskConfig__25} taskStyle={taskStyle} /></BaseLayout></TaskController></MemberController><BaseLayout id="b1c" nodeId="7f59179d-5773-4278-ba5c-d830944fbb1c" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__26} children={children}><ModalSlide id="ee9" nodeId="f1e15c29-1b00-4204-8b44-25def5a35ee9" nodeType="modal-slide" modalSlideConfig={modalSlideConfig} itemStyle={modalSlideItemStyle} iconStyle={iconStyle} titleStyle={titleStyle} subTitleStyle={subTitleStyle} /></BaseLayout><BaseLayout id="b87" nodeId="f76b5b09-7d24-485a-a176-5d18012c9b87" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__28} children={children}><ModalSlide id="ce9" nodeId="fdbd2a53-9673-48b4-93b3-416dda390ce9" nodeType="modal-slide" modalSlideConfig={modalSlideConfig__29} itemStyle={modalSlideItemStyle__29} iconStyle={iconStyle__29} titleStyle={titleStyle__29} subTitleStyle={subTitleStyle__29} /></BaseLayout></BaseLayout><BaseLayout id="f7f" nodeId="04270135-1732-4cdc-be4e-492f26b49f7f" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__30} children={children}><FlexibleDraw id="b61" nodeId="a2ecd77c-248e-4644-99b6-fd2667b99b61" nodeType="flexible-draw" env={process.env.SITE_ENV} activityID={baseConfig.activityID} animationConfig={animationConfig} ruleStyleConfig={ruleStyleConfig} taskStyleConfig={taskStyleConfig} prizeStyleConfig={prizeStyleConfig} /></BaseLayout><Image id="f68" nodeId="d4a402c7-e476-4724-8ce0-4c445849df68" nodeType="image" imageConfig={imageConfig__32} imageStyle={imageStyle__32} env={process.env.SITE_ENV}></Image><BaseLayout id="abf" nodeId="76f67173-29c6-44d4-b925-1cbf4b6a5abf" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__33} children={children}><SwiperContainer id="cd6" nodeId="eb7ea0f3-1d70-4a5a-a172-c58ce1365cd6" nodeType="swiper" swiperConfig={swiperConfig} swiperStyle={swiperStyle} children={children}><Image id="cbe" nodeId="212a01b4-b48a-467e-88d5-9af00fd44cbe" nodeType="image" imageConfig={imageConfig__35} imageStyle={imageStyle__35} env={process.env.SITE_ENV}></Image><Image id="f2c" nodeId="2d5aab2a-f955-45e4-ad4a-25f7d0228f2c" nodeType="image" imageConfig={imageConfig__36} imageStyle={imageStyle__36} env={process.env.SITE_ENV}></Image><Image id="ada" nodeId="7dbe750d-91d8-4758-90c4-cd841e439ada" nodeType="image" imageConfig={imageConfig__37} imageStyle={imageStyle__37} env={process.env.SITE_ENV}></Image><Image id="ca6" nodeId="ca3e0003-5aaa-49b1-be8d-d674a33fcca6" nodeType="image" imageConfig={imageConfig__38} imageStyle={imageStyle__38} env={process.env.SITE_ENV}></Image><Image id="fc9" nodeId="d5e97777-bfe6-4fc5-b809-0b3aadb06fc9" nodeType="image" imageConfig={imageConfig__39} imageStyle={imageStyle__39} env={process.env.SITE_ENV}></Image><Image id="a89" nodeId="b32234dc-35bc-489f-b841-72aab188ea89" nodeType="image" imageConfig={imageConfig__40} imageStyle={imageStyle__40} env={process.env.SITE_ENV}></Image></SwiperContainer></BaseLayout><BaseLayout id="d96" nodeId="74b4f64f-c48e-4bbe-83c9-9da61253cd96" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__41} children={children}><Image id="b4a" nodeId="f7f01092-8c93-4000-926b-64cb975e0b4a" nodeType="image" imageConfig={imageConfig__42} imageStyle={imageStyle__42} env={process.env.SITE_ENV}></Image><TabNavs id="d6f" nodeId="f5038755-1bd9-40e6-a7bd-9eab4491ad6f" nodeType="tab-navs" tabNavsConfig={tabNavsConfig} tabNavsStyle={tabNavsStyle} children={children}><BaseLayout id="b63" nodeId="7c7a0a44-ec5e-4669-be25-44f1c9c5bb63" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__44} children={children}><HotZone id="c60" nodeId="c109571b-fb6a-469c-97e0-8f72e60f5c60" nodeType="hot-zone" hotZoneConfig={hotZoneConfig} hotZoneStyle={hotZoneStyle} env={process.env.SITE_ENV} /><HotZone id="b76" nodeId="ebe319a9-2900-47ea-8339-bcce9e74fb76" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__46} hotZoneStyle={hotZoneStyle__46} env={process.env.SITE_ENV} /></BaseLayout><BaseLayout id="eae" nodeId="bb039e73-8990-4c14-95f7-db1c59defeae" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__47} children={children}><HotZone id="a20" nodeId="7b784f35-9f66-4118-87c7-0b11290faa20" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__48} hotZoneStyle={hotZoneStyle__48} env={process.env.SITE_ENV} /><HotZone id="d31" nodeId="831440de-ba41-4431-8351-6eb48c372d31" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__49} hotZoneStyle={hotZoneStyle__49} env={process.env.SITE_ENV} /><HotZone id="c3b" nodeId="c4db94e8-3724-45e8-9d7c-b1a50cb1bc3b" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__50} hotZoneStyle={hotZoneStyle__50} env={process.env.SITE_ENV} /></BaseLayout><BaseLayout id="fe1" nodeId="1f6f5545-4c0a-4b46-9e78-a4fccd556fe1" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__51} children={children}><HotZone id="e2d" nodeId="d3deac44-18b2-46bd-aa1d-4fb251639e2d" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__52} hotZoneStyle={hotZoneStyle__52} env={process.env.SITE_ENV} /><HotZone id="e44" nodeId="d5c8c3be-0adf-4fc4-87e0-e6f6ffee7e44" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__53} hotZoneStyle={hotZoneStyle__53} env={process.env.SITE_ENV} /></BaseLayout><BaseLayout id="ba0" nodeId="79747eec-cc70-432f-80d4-c23bc3224ba0" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__54} children={children}><HotZone id="cf5" nodeId="025d2cd6-a156-420e-8170-976119df3cf5" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__55} hotZoneStyle={hotZoneStyle__55} env={process.env.SITE_ENV} /><HotZone id="ba8" nodeId="dc156ba2-337c-4430-9917-297192528ba8" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__56} hotZoneStyle={hotZoneStyle__56} env={process.env.SITE_ENV} /><HotZone id="df1" nodeId="5876431f-a35b-4d5a-bf37-1bd8a82b6df1" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__57} hotZoneStyle={hotZoneStyle__57} env={process.env.SITE_ENV} /></BaseLayout><BaseLayout id="a29" nodeId="b02cb0c5-4edf-4bd2-954d-33feebca3a29" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__58} children={children}><HotZone id="e02" nodeId="5ff2b358-55e1-431a-bb7b-0389ade63e02" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__59} hotZoneStyle={hotZoneStyle__59} env={process.env.SITE_ENV} /><HotZone id="d0f" nodeId="33f31a78-67ca-4cee-8bd0-1ea91917dd0f" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__60} hotZoneStyle={hotZoneStyle__60} env={process.env.SITE_ENV} /><HotZone id="efe" nodeId="186cccfe-47de-4705-81f3-eae8feeedefe" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__61} hotZoneStyle={hotZoneStyle__61} env={process.env.SITE_ENV} /><HotZone id="d6b" nodeId="fa47ee56-ec8b-4d03-b64b-b07d57547d6b" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__62} hotZoneStyle={hotZoneStyle__62} env={process.env.SITE_ENV} /></BaseLayout><BaseLayout id="d3b" nodeId="6dad9d21-d093-4cbe-a04b-f52928de9d3b" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__63} children={children}><HotZone id="e6f" nodeId="cdf110f2-1707-49af-83f0-ff52d36ade6f" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__64} hotZoneStyle={hotZoneStyle__64} env={process.env.SITE_ENV} /><HotZone id="a25" nodeId="5fbf6ab6-390d-4058-b739-24a5442bda25" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__65} hotZoneStyle={hotZoneStyle__65} env={process.env.SITE_ENV} /><HotZone id="e3d" nodeId="47bea9a5-a213-4d30-992a-6b8166ed3e3d" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__66} hotZoneStyle={hotZoneStyle__66} env={process.env.SITE_ENV} /><HotZone id="c03" nodeId="c1365ba2-6be1-4c0c-a63d-c31d3140dc03" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__67} hotZoneStyle={hotZoneStyle__67} env={process.env.SITE_ENV} /></BaseLayout></TabNavs></BaseLayout><HotZone id="c97" nodeId="aa2b7d76-f495-41f8-8a34-087f883a1c97" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__68} hotZoneStyle={hotZoneStyle__68} env={process.env.SITE_ENV} /><BaseLayout id="d02" nodeId="dc068cb9-c248-4b5b-a67a-006cef97ed02" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__69} children={children}><Image id="ff5" nodeId="32611466-01bc-4132-b132-847d924aeff5" nodeType="image" imageConfig={imageConfig__70} imageStyle={imageStyle__70} env={process.env.SITE_ENV}></Image><TabNavs id="acc" nodeId="22fe51dc-dcae-4640-bfd8-53dbdd0a4acc" nodeType="tab-navs" tabNavsConfig={tabNavsConfig__71} tabNavsStyle={tabNavsStyle__71} children={children}><HotZone id="b0a" nodeId="34f63cf9-5cd5-4397-bec1-3d03cf646b0a" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__72} hotZoneStyle={hotZoneStyle__72} env={process.env.SITE_ENV} /><HotZone id="fbc" nodeId="194b2b27-e791-4a37-be14-0c7a2a9d3fbc" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__73} hotZoneStyle={hotZoneStyle__73} env={process.env.SITE_ENV} /><HotZone id="be3" nodeId="f14778b7-90a7-47b4-ad70-a1dcc51a6be3" nodeType="hot-zone" hotZoneConfig={hotZoneConfig__74} hotZoneStyle={hotZoneStyle__74} env={process.env.SITE_ENV} /></TabNavs></BaseLayout><BaseLayout id="ebc" nodeId="45c39372-b971-4c3d-8b1e-2c2ff4cb1ebc" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__75} children={children}><Image id="f65" nodeId="3e41db8b-5d53-40c9-b74b-d5f748030f65" nodeType="image" imageConfig={imageConfig__76} imageStyle={imageStyle__76} env={process.env.SITE_ENV}></Image><BaseLayout id="fbb" nodeId="c60d0347-52d8-4906-8816-68f0118cffbb" nodeType="base-layout" baseLayoutStyle={baseLayoutStyle__77} children={children}><SwiperContainer id="f78" nodeId="f0ca12fa-5a4f-4003-881c-602b723fff78" nodeType="swiper" swiperConfig={swiperConfig__78} swiperStyle={swiperStyle__78} children={children}><Image id="b77" nodeId="ba7d3b92-b34c-4bcd-9dc3-b1c599898b77" nodeType="image" imageConfig={imageConfig__79} imageStyle={imageStyle__79} env={process.env.SITE_ENV}></Image><Image id="b03" nodeId="ff29405b-5259-4a2f-a115-0164e0cf6b03" nodeType="image" imageConfig={imageConfig__80} imageStyle={imageStyle__80} env={process.env.SITE_ENV}></Image><Image id="a19" nodeId="6c8972c4-a154-451a-8807-32982aa11a19" nodeType="image" imageConfig={imageConfig__81} imageStyle={imageStyle__81} env={process.env.SITE_ENV}></Image><Image id="f5a" nodeId="d3c2c688-1098-48cf-82cb-27d366aa0f5a" nodeType="image" imageConfig={imageConfig__82} imageStyle={imageStyle__82} env={process.env.SITE_ENV}></Image><Image id="e2e" nodeId="0e341ba4-1111-4aae-a4b1-2c1ecd1fce2e" nodeType="image" imageConfig={imageConfig__83} imageStyle={imageStyle__83} env={process.env.SITE_ENV}></Image><Image id="c32" nodeId="6f2c9664-c61a-4d0d-9d2e-6e1df3329c32" nodeType="image" imageConfig={imageConfig__84} imageStyle={imageStyle__84} env={process.env.SITE_ENV}></Image></SwiperContainer></BaseLayout></BaseLayout><Image id="b98" nodeId="9245ac30-10b5-4916-b0fa-0b572a676b98" nodeType="image" imageConfig={imageConfig__85} imageStyle={imageStyle__85} env={process.env.SITE_ENV}></Image></TimeController></WrapContainer>;
});